import React, { useState, useEffect, useContext, Fragment, useRef, useCallback, useMemo } from 'react';
import { Dialog, Transition } from '@headlessui/react'
import { AuthContext } from '../contexts/auth';
import { postNotificationDWH } from '../services/api_calendar';
import Footer from './footer';
import CalendarWeekSelect from './calendar_week_select';
import ComboboxAutocomplete from './combobox_autocomplete';
import { ChevronDownIcon, ChevronUpIcon, BriefcaseIcon, PlusCircleIcon, ChevronRightIcon, ChevronLeftIcon, TrashIcon, PencilSquareIcon, InformationCircleIcon, NoSymbolIcon, PlusIcon, ExclamationTriangleIcon, ClipboardDocumentCheckIcon, EyeSlashIcon, CalendarDaysIcon, ArrowsRightLeftIcon, QuestionMarkCircleIcon, AdjustmentsHorizontalIcon, MapPinIcon, CheckIcon, UserMinusIcon } from '@heroicons/react/24/outline';
import { Link } from 'wouter';
import { getWorkingHoursCompound, getWeeklyWorkingHourCompound } from '../services/api_working_hours';
import { getCalendarWorkingHour, createEmployeeWorkingHour, deleteEmployeeDailyWorkingHour, updateEmployeeDailyWorkingHour, getCalendarTotalHours, updateEmployeeWorkingHourStatus, updateEmployeeDWHOuPair } from '../services/api_calendar';
import { getCompanySettings } from '../services/api_settings';
import Swal from 'sweetalert2';
import { AddDailyWorkingHour } from './add_daily_working_hour_calendar';
import { convertWorkingHourToShifts } from '../utils/timeslots';
import { listOrganizationalUnits } from '../services/api_org_unit';
import { getMonthBlocked } from '../services/api_months_blocked';
import Fetching from './fetching';
import moment from 'moment';
import PairOrgUnit from './pair_org_unit';
import InactiveEmployeesTable from './inactive_employees_table';
import ShiftCard from './shift_card';
import OuSelectionPairDWH from './modal_select_OU_to_pair_DWH';
import PopoverComponentCustom from './popover_component';
import LocalBarIcon from '@mui/icons-material/LocalBar';
import TabellaTurnoGiornaliero from './tabella_visualizza_turno giornaliero';
import { formatHoursAndMinutes, buildSlotsByDateFromPreviews } from '../utils/workTimeCount';
import AddGiustificativoModalAssignWH from './modal_add_giustificativo_assegna_turni';
import CustomTooltipComponent from './custom_tooltip_component';
import { v2EstraiMessaggiErrore, getUiErrorMessage } from '../services/utils';
import SchedulerContextBar from './scheduler_context_bar';
import WorkingAreaAssignmentModal from './working_area_assignment_modal';
import WorkingAreaBulkAssignmentModal from './working_area_bulk_assignment_modal';

// import { EditDailyWorkingHour } from './edit_daily_working_hour_calendar';


function isWeekWorkingHours(obj) {
    if (!obj)
        return false;
    return 'slots_by_weekday' in obj;
}

// Ordina i turni in base all'orario di inizio del primo time_slot
const sortShiftsByStartTime = (shifts = []) => {
  const toMinutes = (time) => {
    if (!time) return 0;
    const [h, m] = time.split(':').map(Number);
    return h * 60 + m;
  };

  return [...shifts].sort((a, b) => {
    const aStart = a.time_slots?.[0]?.start_at || '24:00';
    const bStart = b.time_slots?.[0]?.start_at || '24:00';

    return toMinutes(aStart) - toMinutes(bStart);
  });
};

function stripUnitaFromName(name) {
  if (!name) return name;
  // rimuove " - Unità: qualsiasi_cosa" alla fine
  return name.replace(/\s*-\s*Unità:.*$/i, '');
}


const V2TableAssignWh = () => {
    const { token, profile } = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingEmployee, setLoadingEmployee] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorSetting, setErrorSetting] = useState(false);
    const [loadingTotalHours, setLoadingTotalHours] = useState(false);
    const [isTotalHoursError, setIsTotalHoursError] = useState(false);
    const [selectedActiveContractEmployees, setSelectedActiveContractEmployees] = useState([]);
    const [currentWeek, setCurrentWeek] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(new Date());
    const [firstDayOfMonth, setFirstDayOfMonth] = useState(new Date());
    const currentMonthName = firstDayOfMonth.toLocaleString('it-IT', { month: 'long' }).toLowerCase();
    const [calendarVisible, setCalendarVisible] = useState(false);
    const [workingHours, setWorkingHours] = useState([]);
    const [employeeWorkingHours, setEmployeeWorkingHours] = useState([]);
    const [selectedDay, setSelectedDay] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedWorkingHourId, setSelectedWorkingHourId] = useState(null);
    const [selectedWeeklyWorkingHourId, setSelectedWeeklyWorkingHourId] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState();
    const [employeesWithActiveContract, setEmployeesWithActiveContract] = useState([]);
    const [showInactiveEmployee, setShowInactiveEmployee] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');
    const [employeesCalendarData, setEmployeesCalendarData] = useState([]);
    const [weeklyWorkingHours, setWeeklyWorkingHours] = useState([]);
    const daysOfWeek = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'];
    const [selectedUnit, setSelectedUnit] = useState(null);
    const [units, setUnits] = useState([]); 
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [holidays, setHolidays] = useState([]);
    const [notificationsToSend, setNotificationsToSend] = useState([]);
    const [selectedNotifications, setSelectedNotifications] = useState([]);
    const [selectedEmployeeName, setSelectedEmployeeName] = useState({});
    const [totalResultActiveContract, setTotalResultActiveContract] = useState(0);
    const [pageActiveContract, setPageActiveContract] = useState(1);
    const [pageSizeActiveContract, setPageSizeActiveContract] = useState(25);
    const [totalPlannedHours, setTotalPlannedHours] = useState(0);
    const [totalAssignedHours, setTotalAssignedHours] = useState(0);
    const [temporarySelectedUnit, setTemporarySelectedUnit] = useState(selectedUnit || null);
    const [selectedOuToPair, setSelectedOuToPair] = useState(null);
    const [unconfirmedShiftsIds, setUnconfirmedShiftsIds] = useState([]);
    const [isModalOuPairingOpen, setIsModalOuPairingOpen] = useState(false);
    const [selectedDWH, setSelectedDWH] = useState({});
    const [blockedMonths, setBlockedMonths] = useState([]);
    const [oraInizio, setOraInizio] = useState('');
    const [oraFine, setOraFine] = useState('');
    const [showModalAddGiustificativo, setShowModalAddGiustificativo] = useState(false);
    const [settingHiddenBreak, setSettingHiddenBreak] = useState(false);
    const [unitsLoaded, setUnitsLoaded] = useState(false);
    const [showBreaks, setShowBreaks] = useState(true);
    const [showWorkingAreas, setShowWorkingAreas] = useState(false);
    const [dragSource, setDragSource] = useState(null);
    const [dragMode, setDragMode] = useState('move'); // copy | move
    const [expandedRows, setExpandedRows] = useState({});
    const [expandAllRows, setExpandAllRows] = useState(false);
    const [showTurniFissi, setShowTurniFissi] = useState(false);
    const [showTurniVariabili, setShowTurniVariabili] = useState(false);
    const [isShiftOperationRunning, setIsShiftOperationRunning] = useState(false);
    const [workingAreaModalOpen, setWorkingAreaModalOpen] = useState(false);
    const [selectedWorkingAreaEmployee, setSelectedWorkingAreaEmployee] = useState(null);
    const [selectedWorkingAreaDay, setSelectedWorkingAreaDay] = useState(null);
    const [showBulkWorkingAreaModal, setShowBulkWorkingAreaModal] = useState(false);
    const [selectedWorkingArea, setSelectedWorkingArea] = useState(null);
    // const [isNightShiftActive, setIsNightShiftActive] = useState(false);
    
    const controller = useRef(null);

    const selectedWorkingHour = Array.isArray(workingHours) 
    ? workingHours.find(wh => wh.id === selectedWorkingHourId) 
    : null;

    const wwhEmployeeData = Array.isArray(weeklyWorkingHours) 
    ? weeklyWorkingHours.find(wwh => wwh.id === selectedWeeklyWorkingHourId) 
    : null;

    
    const wwhEmployeeDataDisplay = selectedWorkingHour || wwhEmployeeData;  
    const hidePaginationActive = totalResultActiveContract <= pageSizeActiveContract;
    const isProfileComplete = profile.has_complete_profile;

    const canManageShifts =
        profile.customer_type !== 'employee' ||
        profile.employee?.permissions?.includes('hr.manage_shifts_all') ||
        profile.employee?.permissions?.includes('hr.manage_shifts_ou');


    const canManageJustifications =
        profile.customer_type !== 'employee' ||
        profile.employee?.permissions.includes('hr.manage_justification_all') ||
        profile.employee?.permissions.includes('hr.manage_justification_ou');

    const canViewWorkingAreas =
        profile.customer_type !== "employee" ||
        profile.employee?.permissions?.includes("hr.view_working_area_all") ||
        profile.employee?.permissions?.includes("hr.view_working_area_ou");
    
    const canManageWorkingAreas =
        profile.customer_type !== "employee" ||
        profile.employee?.permissions?.includes("hr.manage_working_area_all") ||
        profile.employee?.permissions?.includes("hr.manage_working_area_ou");

    const canLoadWorkingAreas = canViewWorkingAreas || canManageWorkingAreas;

    const shiftAssignmentOptions = [
        {value: "ASSEGNA TURNO GIORNALIERO", label: "TURNO GIORNALIERO", description: "Assegna un turno giornaliero già configurato"},
        {value: "ASSEGNA TURNO SETTIMANALE", label: "TURNO SETTIMANALE", description: "Assegna una configurazione settimanale"},
        {value: "CREA FASCIA ORARIA", label: "CREA FASCIA ORARIA", description: "Definisci manualmente gli intervalli della giornata"},
    ];

    
    useEffect(() => {
        if (!token) return;
        
        let cancelled = false;
        (async () => {
            try {
            const settings = await getCompanySettings(token, 'payrolls');
            const allowHidden = Boolean(settings?.allow_hidden_breaks ?? false);
            if (!cancelled) setSettingHiddenBreak(allowHidden);
            } catch (e) {
            console.error('Errore caricamento setting:', e);
            if (!cancelled) setSettingHiddenBreak(false);
            }
        })();
    
        return () => { cancelled = true; };
    }, [token]);


    useEffect(() => {
        if (!token) return;
        const fetchUnits = async () => {
            setIsLoading(true);
            setIsError(false);
    
            try {
                const response = await listOrganizationalUnits(token, true, null, 'shifts');

                const list = response.data || [];
                setUnits(list);
                
                if (!selectedUnit && list.length > 0) {
                    setSelectedUnit(list[0]);
                }
            } catch (error) {
                console.error('Error fetching units:', error);
                {(error?.response?.status !== 402) &&
                    setIsError(true);
                    setIsLoading(false);
                }
            } finally {
                setIsLoading(false);
                setUnitsLoaded(true);
            }
        };
    
        fetchUnits();
    }, [token]);

    useEffect(() => {
        if (selectedUnit) {
            setTemporarySelectedUnit(selectedUnit);
        } else {
            setTemporarySelectedUnit(null);
        }
    }, [selectedUnit]);

    const handleWorkingAreaSelection = (workingArea) => {
        setSelectedWorkingArea(workingArea);
        setPageActiveContract(1);

        // Se viene selezionato un filtro area
        if (workingArea != null) {
            // Mostra le informazioni sulle aree
            setShowWorkingAreas(true);

            // Mostra tutti i turni
            const allExpanded = {};

            getToggleTargetEmployees().forEach((emp) => {
                allExpanded[emp.id] = true;
            });

            setExpandedRows(allExpanded);
            setExpandAllRows(true);
            setShowTurniFissi(true);
            setShowTurniVariabili(true);
            setShowBreaks(false);
        }
    };

    const selectedWorkingAreaId = useMemo(() => {
        if (selectedWorkingArea == null) {
            return null;
        }

        // "Senza area associata"
        if (
            selectedWorkingArea === '__NO_AREA__' ||
            selectedWorkingArea?.id === '__NO_AREA__'
        ) {
            return 'none';
        }

        // Eventuale formato già normalizzato
        if (
            selectedWorkingArea === 'none' ||
            selectedWorkingArea?.id === 'none'
        ) {
            return 'none';
        }

        // ID passato direttamente
        if (typeof selectedWorkingArea === 'number') {
            return selectedWorkingArea;
        }

        // Oggetto WorkingArea
        return selectedWorkingArea?.id ?? null;
    }, [selectedWorkingArea]);

    const loadCalendar = useCallback(async () => {
        if (currentWeek.length === 0) return;

        if (controller.current) {
            controller.current.abort();
        }

        const currentController = new AbortController();

        controller.current = currentController;

        const signal = currentController.signal;

        setIsError(false);
        setLoadingEmployee(true);
    
        try {
            const startDate = formatDateWeekSelected(currentWeek[0]);
            const endDate = formatDateWeekSelected(currentWeek[currentWeek.length - 1]);

            const calendarResponse = await getCalendarWorkingHour(
                token, { startDate, endDate },
                selectedUnit?.id, selectedActiveContractEmployees.map((e) => e.id),
                pageActiveContract, pageSizeActiveContract,
                signal,
                'shifts',
                selectedWorkingAreaId
            );
            
            let arrayCalendarResponse = [];
            if (Array.isArray(calendarResponse.results)) {
                arrayCalendarResponse = calendarResponse.results;
            }

            const activeEmployees = arrayCalendarResponse.map((employee) => ({
                first_name: employee.first_name,
                last_name: employee.last_name,
                cf: employee.cf,
                id: employee.id,
                shift_type: employee.typology,
                week_hours: (() => {
                    const dayWithHours = employee.days.find((day) => day.week_hours !== null && day.week_hours !== undefined);
                    return dayWithHours?.week_hours ?? 0;
                })(),
            }));
            setTotalResultActiveContract(calendarResponse.count);
    
            setEmployeesCalendarData(calendarResponse.results);

            const holidaysData = [];
            arrayCalendarResponse.forEach((employee) => {
                employee.days.forEach((day) => {
                    if (day.holidays?.length > 0) {
                        day.holidays.forEach((holiday) => {
                            holidaysData.push({ date: day.date, name: holiday.name });
                        });
                    }
                });
            });
            setHolidays(holidaysData);
    
            setEmployeesWithActiveContract(activeEmployees);
            setSelectedEmployees(activeEmployees);
    
            const employeeWorkingHoursData = arrayCalendarResponse.flatMap((entry) =>
                entry.days.map((day) => {
                    const justifications = Array.isArray(day.justification_requests) ? day.justification_requests : [];

                    const justificationDurations = justifications.reduce((acc, jr) => acc + (jr.duration || 0), 0);

                    return {
                        employeeId: entry.id,
                        employeeCf: entry.cf,
                        employeeLastName: entry?.last_name,
                        employeeFirstName: entry?.first_name,
                        date: day.date,
                        typology: entry.typology,
                        shifts: Array.isArray(day.shifts) ? day.shifts.map((shift) => ({
                            ref_name: shift.ref_name,
                            ref_ou: shift.ref_ou,
                            dailyWorkingHourId: shift.daily_working_hour,
                            status: shift.status,
                            typology: shift.typology,
                            workingHourId: shift.typology === 'working_hour' ? shift.ref_id : null,
                            time_slots: Array.isArray(shift.time_slots) 
                                ? shift.time_slots.map((slot) => ({
                                        ...slot,
                                        date: day.date,
                                    }))
                                : [],
                        })) : [],
                        has_active_contract: day.has_active_contract,
                        week_hours: (() => {
                            const dayWithWeekHours = entry.days.find((currentDay) => currentDay.week_hours !== null && currentDay.week_hours !== undefined);
                            return (dayWithWeekHours?.week_hours ?? null);
                        })(),
                        has_justifications: day.has_justifications,
                        shift_type: day.shift_type,
                        justification_requests: justifications,
                        justification_duration_total: justificationDurations,
                    };
                })
            );
                
            // setSelectedEmployees(activeEmployees);
            setEmployeeWorkingHours(employeeWorkingHoursData);

            const unconfirmedShifts = employeeWorkingHoursData.flatMap((emp) =>
                emp.shifts
                    .filter((shift) => shift.status === false)
                    .map((shift) => ({
                        employeeId: emp.employeeId,
                        dailyWorkingHourId: shift.dailyWorkingHourId,
                        employee: emp,
                        shiftDays: emp.date,
                    }))
            );

            setUnconfirmedShiftsIds(unconfirmedShifts);

            const blockedMonthsResponse = await getMonthBlocked(token, { startDate, endDate }, 'shifts');

            setBlockedMonths(blockedMonthsResponse);
        } catch (error) {
            if (error?.name !== "CanceledError" && error?.name !== "AbortError") {
                console.error(error);

                if (controller.current === currentController) {
                    setIsError(true);
                }
            }
        } finally {
            if (controller.current === currentController) {
                setLoadingEmployee(false);
            }
        }
    }, [token, currentWeek, selectedUnit?.id, selectedActiveContractEmployees, pageActiveContract, pageSizeActiveContract, selectedWorkingAreaId]);
    
    useEffect(() => {
        loadCalendar();

        return () => {
            controller.current?.abort();
        };
    }, [loadCalendar]);

    const { weekStartISO, weekEndISO } = useMemo(() => {
        if (!currentWeek || currentWeek.length === 0) {
            return { weekStartISO: null, weekEndISO: null };
        }
        const start = moment(currentWeek[0]).format("YYYY-MM-DD");
        const end   = moment(currentWeek[currentWeek.length - 1]).format("YYYY-MM-DD");
        return { weekStartISO: start, weekEndISO: end };
    }, [currentWeek]);


    const updateTotalHours = useCallback(async () => {
        if (!currentWeek || currentWeek.length === 0) return;

        try {
            const startDate = formatDateWeekSelected(currentWeek[0]);
            const endDate = formatDateWeekSelected(currentWeek[currentWeek.length - 1]);

            setLoadingTotalHours(true);
            setIsTotalHoursError(false);

            const totalHoursResponse = await getCalendarTotalHours(
                token,
                { startDate, endDate },
                selectedUnit?.id,
                selectedActiveContractEmployees.map(e => e.id),
                'shifts'
            );

            let arraytotalHours = [];
            if (Array.isArray(totalHoursResponse.results)) {
                arraytotalHours = totalHoursResponse.results;
            }

            setTotalPlannedHours(totalHoursResponse.week_hours_expected);
            setTotalAssignedHours(totalHoursResponse.week_hours_actual);
            setLoadingTotalHours(false);
        } catch (error) {
            if (error?.name != 'CanceledError') {
                console.error("Errore nell'aggiornamento delle ore totali:", error);
                {(error?.response?.status !== 402) &&
                    setIsTotalHoursError(true);
                    setLoadingTotalHours(false);
                }
            }
        }
    }, [token, currentWeek, selectedUnit, selectedActiveContractEmployees]);

    useEffect(() => {
        updateTotalHours();
    }, [updateTotalHours]);

    // useEffect(() => {
    //     const fetchSettings = async () => {
    //         try {
    //         const response = await getCompanySettings(token, 'attendance');
    //         const settings = response.data;
            
    //         setIsNightShiftActive(settings?.night_shift_active || false);
    //         setOraInizio(moment(settings?.night_shift_start, "HH:mm:ss").format("HH:mm"));
    //         setOraFine(moment(settings?.night_shift_end, "HH:mm:ss").format("HH:mm"));

    //         } catch (err) {
    //         setErrorSetting("Errore durante il caricamento delle impostazioni.");
    //         console.error(err);
    //     }
    // };

    // fetchSettings();
    // }, [token]);
    
    const isDayBlocked = (date) => {
        const day = new Date(date);
        const year = day.getFullYear();
        const month = day.getMonth() + 1;
        
        return blockedMonths.some(blocked => blocked.year === year && blocked.month === month);
    };
    
    const handleNextPageActive = () => {
        if (pageActiveContract * pageSizeActiveContract < totalResultActiveContract) {
          setPageActiveContract(prevPage => prevPage + 1);
        }
    };
    
    const handlePreviousPageActive = () => {
        if (pageActiveContract > 1) {
            setPageActiveContract(prevPage => prevPage - 1);
        }
    };

    const handlePageSizeActiveChange = (newPageSize) => {
        setPageSizeActiveContract(newPageSize);
        setPageActiveContract(1);
    };
    
    const isWeekend = (date) => {
        const dayOfWeek = new Date(date).getDay();
        return dayOfWeek === 0; // 0 = Domenica
    };

    const formatDateWeekSelected = (date) => {

        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    
    // 1) DAILY
    const loadWorkingHours = useCallback(
        async (ouIdParam) => {
            if (!token) return;

            // se ouIdParam è passato lo usiamo così com’è (può essere anche null),
            // altrimenti usiamo la selectedUnit corrente, e se non c'è → null
            const ouId = (ouIdParam !== undefined)
            ? ouIdParam                  // può essere number o null
            : (selectedUnit?.id ?? null);

            try {
            const workingHoursData = await getWorkingHoursCompound(
                token,
                ouId,          // <- se null: turni senza OU associata
                "shifts",
                null
            );
                setWorkingHours(workingHoursData || []);
            } catch (error) {
                console.error("Errore durante il recupero dei turni giornalieri", error);
            }
        },
        [token, selectedUnit?.id]
    );

    // 2) WEEKLY
    const loadWeeklyWorkingHours = useCallback(
        async (ouIdParam) => {
            if (!token) return;

            const ouId = (ouIdParam !== undefined)
            ? ouIdParam
            : (selectedUnit?.id ?? null);

            try {
                const weeklyWorkingHoursData = await getWeeklyWorkingHourCompound(
                    token,
                    ouId,
                    null,
                    "shifts",
                    null
                );
                setWeeklyWorkingHours(weeklyWorkingHoursData || []);
            } catch (error) {
                console.error("Errore durante il recupero dei turni settimanali", error);
            }
        },
        [token, selectedUnit?.id]
    );

    useEffect(() => {
        if (!token || !unitsLoaded) return;
        loadWorkingHours();
        loadWeeklyWorkingHours();
    }, [token, unitsLoaded, selectedUnit?.id, loadWorkingHours, loadWeeklyWorkingHours]);

    
    const handleSelectionActiveContractChange = (newSelectedEmployees) => {
        setSelectedActiveContractEmployees(newSelectedEmployees);
    };

    const handleDeselectEmployee = (employeeId) => {
        setSelectedActiveContractEmployees((prevSelected) =>
            prevSelected.filter((emp) => emp.id !== employeeId)
        );
    };

    const handleResetSelection = () => {
        setSelectedActiveContractEmployees([]);
    };

    useEffect(() => {
        const today = new Date();
        setCurrentWeek(getCompleteWeek(today));
    }, []);

    const getCompleteWeek = (date) => {
        const currentDayOfWeek = date.getDay();
        const mondayDiff = currentDayOfWeek === 0 ? -6 : 1 - currentDayOfWeek;
        const monday = new Date(date);
        monday.setDate(date.getDate() + mondayDiff);
        const weekDays = [monday];
        for (let i = 1; i < 7; i++) {
            const day = new Date(monday);
            day.setDate(monday.getDate() + i);
            weekDays.push(day);
        }
        return weekDays;
    };

    const getWeekRange = (monday, sunday) => {
        const startDay = monday.getDate();
        const endDay = sunday.getDate();
    
        const startMonth = monday.toLocaleDateString('it-IT', { month: 'long' });
        const endMonth = sunday.toLocaleDateString('it-IT', { month: 'long' });
    
        if (startMonth !== endMonth) {
            return `${startDay} ${startMonth} - ${endDay} ${endMonth}`;
        }
    
        return `${startDay} - ${endDay} ${startMonth}`;
    };

    const formatDay = (date) => {
        if (!date) return "";
        const options = { weekday: 'short', day: 'numeric' };
        return date.toLocaleDateString('it-IT', options);
    };

    const handleWeekSelect = (weekDays) => {
        setCurrentWeek(weekDays);
        if (weekDays.length > 0) {
            const firstDayOfWeek = weekDays[0];
            setSelectedMonth(new Date(firstDayOfWeek.getFullYear(), firstDayOfWeek.getMonth(), 1));
        }
    };

    const handleNavigateWeek = (direction) => {
        const newMonday = new Date(currentWeek[0]);
        newMonday.setDate(newMonday.getDate() + 7 * direction);
        setCurrentWeek(getCompleteWeek(newMonday));
        setSelectedMonth(new Date(newMonday.getFullYear(), newMonday.getMonth(), 1));
    };
    
    const handleSelectClick = () => {
        setCalendarVisible(!calendarVisible);
    };

    const shiftAssigned = currentWeek.map((day, index) => {
        const dateSelected = formatDay(day);
        const selectedEmployeeShift = selectedWorkingHour?.time_slots.find((item) => item.day === dateSelected);
        
        return {
            day: dateSelected,
            shiftHour: selectedEmployeeShift ? selectedEmployeeShift.id : '',
        };
    });
    
    const formatDate = (date) => {
        return moment(date).format('YYYY-MM-DD')
        // return date.toISOString().split('T')[0];
    };

    const handlePlusCircleClick = (employeeId, day, cf, lastName, firstName, selectedUnit) => {
        if (profile.customer_type !== 'employee' || 
            profile.employee?.permissions.includes('hr.manage_shifts_all') || 
            profile.employee?.permissions.includes('hr.manage_shifts_ou')) {
            
            handleSelectedDay(employeeId, day, cf, lastName, firstName, selectedUnit.id);
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Non hai i permessi per eseguire questa azione',
                confirmButtonText: 'OK'
            });
        }
    };
    
    const handleSelectedDay = (employeeId, day, cf, employeeLN, employeeFN) => {
        setSelectedEmployee(employeeId);
        setSelectedDay(day);

        const fullName = (employeeLN && employeeFN) 
            ? `${employeeLN} ${employeeFN}`.trim() 
            : cf;

        setSelectedEmployeeName(fullName);
        
        // const currentEmployee = employeesWithActiveContract.find(employee => employee.id === employeeId);
        const employeeCalendarData = employeesCalendarData.find(data => data.id === employeeId);
        const typology = employeeCalendarData ? employeeCalendarData.typology : null;

        const dayBlocked = isDayBlocked(day); 

        if (dayBlocked) {
            Swal.fire({
                icon: 'error',
                title: 'Il giorno è bloccato',
                text: 'Non è possibile modificare questo giorno.',
                showConfirmButton: true,
                confirmButtonText: 'OK',
            });
            return;
        }
    
        if (typology === 'fisso') {
            Swal.fire({
                icon: 'info',
                title: 'Turno Fisso',
                text: 'Il dipendente selezionato ha il contratto con turno fisso e può essere assegnato nella sezione anagrafica',
                showCancelButton: true,
                confirmButtonText: 'Vai all\'anagrafica',
                cancelButtonText: 'Annulla',
                cancelButtonColor: '#d1d5db',
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.href = `/dipendenti/${cf}/edit?tab=4`;
                }
            });
        } else {
            setModalOpen(true);
        }
    };

    const handleTemporarySelectUnit = (selectedUnit) => {
        setTemporarySelectedUnit(() => selectedUnit);
    };
    

    useEffect(() => {
    }, [temporarySelectedUnit, selectedUnit]);  
    
    
    const toMinutes = (time) => {
        if (!time) return 0;
        const [h, m] = time.split(':').map(Number);
        return h * 60 + m;
    };

    const minutesToTime = (mins) => {
        if (mins === 24 * 60) return '24:00';
        const h = Math.floor(mins / 60) % 24;
        const m = mins % 60;
        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
    };

    const buildSlotsByDateFromPreviews = (selectedDay, shiftPreviews) => {
        // selectedDay può essere Date o stringa
        const baseDate = moment(selectedDay);
        const slotsByDate = {};

        const pushSlot = (dateMoment, slot) => {
            const dateKey = dateMoment.format('YYYY-MM-DD');
            if (!slotsByDate[dateKey]) slotsByDate[dateKey] = [];

            slotsByDate[dateKey].push({
            start_at: slot.start_at,
            end_at: slot.end_at,
            breaks: (slot.breaks || []).map(b => ({
                start_at: b.start_at,
                end_at: b.end_at,
                is_visible: b.is_visible,
            })),
            });
        };

        (shiftPreviews || []).forEach(preview => {
            if (!preview?.workStartTime || !preview?.workEndTime) return;

            const { workStartTime, workEndTime, breaks = [], crossesMidnight } = preview;

            const isCross =
            crossesMidnight === true ||
            (workStartTime && workEndTime && workEndTime < workStartTime);

            // 🔹 Caso semplice: NON attraversa la mezzanotte
            if (!isCross) {
            pushSlot(baseDate, {
                start_at: workStartTime,
                end_at: workEndTime,
                breaks,
            });
            return;
            }

            // 🔹 Caso che attraversa la mezzanotte: 22:00 → 06:00
            const day1 = baseDate.clone();
            const day2 = baseDate.clone().add(1, 'day');

            const startMin = toMinutes(workStartTime);
            const endMin = toMinutes(workEndTime);

            const slotDay1 = {
            start_at: workStartTime, // es. 22:00
            end_at: '24:00',
            breaks: [],
            };

            const slotDay2 = {
            start_at: '00:00',
            end_at: workEndTime,     // es. 06:00
            breaks: [],
            };

            breaks.forEach(b => {
            if (!b.start_at || !b.end_at) return;

            const bStart = toMinutes(b.start_at);
            const bEnd = toMinutes(b.end_at);

            const baseBreak = {
                start_at: b.start_at,
                end_at: b.end_at,
                is_visible: b.is_visible,
            };

            // pausa NON attraversa mezzanotte
            if (bEnd >= bStart) {
                // se >= ora inizio turno → parte prima di mezzanotte
                if (bStart >= startMin) {
                slotDay1.breaks.push(baseBreak);
                } else {
                // altrimenti la consideriamo nel giorno dopo (00–06)
                slotDay2.breaks.push(baseBreak);
                }
            } else {
                // pausa attraversa la mezzanotte (es. 23:50 → 00:20)
                // spezzata in due
                slotDay1.breaks.push({
                start_at: minutesToTime(bStart),
                end_at: '24:00',
                is_visible: b.is_visible,
                });
                slotDay2.breaks.push({
                start_at: '00:00',
                end_at: minutesToTime(bEnd),
                is_visible: b.is_visible,
                });
            }
            });

            pushSlot(day1, slotDay1); // giorno selezionato
            pushSlot(day2, slotDay2); // giorno successivo
        });

        return slotsByDate;
    };

    const handleSaveWorkingHour = async (shiftPreviews) => {       
        const formattedDate = moment(selectedDay).format('DD/MM/YYYY');

        // --- caso CREAZIONE fascia oraria personalizzata ---
        if (selectedOption === "CREA FASCIA ORARIA") {
            // 1) Costruisco mappa data → time_slots (gestisce anche gli slot notturni)
            const slotsByDate = buildSlotsByDateFromPreviews(selectedDay, shiftPreviews);

            if (!Object.keys(slotsByDate).length) {
                Swal.fire({
                    icon: 'error',
                    title: 'Errore',
                    text: 'Nessuna fascia oraria valida da salvare.',
                });
                return;
            }

            try {
                if (selectedEmployee === undefined) {
                    throw new Error('Nessun dipendente selezionato');
                }

                // Spinner unico per tutte le date
                Swal.fire({
                    title: 'Assegnazione turno...',
                    icon: 'info',
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                // Copie mutabili degli state
                let updatedEmployeeWorkingHours = [...employeeWorkingHours];
                const newUnconfirmed = [...unconfirmedShiftsIds];
                const newNotifications = [...notificationsToSend];

                const successes = [];
                const failures = [];

                // 2) Una chiamata per ogni data (giorno selezionato + eventuale giorno successivo)
                for (const [dateISO, slots] of Object.entries(slotsByDate)) {
                    const workingHourData = {
                        date: dateISO,
                        working_hour: null,
                        time_slots: slots,
                        ou: temporarySelectedUnit?.id,
                        name: temporarySelectedUnit?.name,
                        typology: 'custom',
                    };

                    try {
                        const responseDWH = await createEmployeeWorkingHour(
                            token,
                            selectedEmployee,
                            workingHourData
                        );

                        const time_slots = responseDWH.working_hour
                            ? convertWorkingHourToShifts(responseDWH.working_hour, workingHours)
                            : responseDWH.time_slots;

                        const isCustom = true; // in questo ramo è sempre custom

                        await updateTotalHours();

                        const indexToUpdate = updatedEmployeeWorkingHours.findIndex(
                            entry => entry.employeeId === selectedEmployee && entry.date === responseDWH.date
                        );

                        const newShift = {
                            ref_name: responseDWH.ref_name,
                            ref_ou: responseDWH.ou,
                            dailyWorkingHourId: responseDWH.id,
                            typology: isCustom ? 'custom' : responseDWH.typology,
                            workingHourId: null,
                            time_slots: time_slots,
                        };

                        if (indexToUpdate !== -1) {
                            const oldShifts = updatedEmployeeWorkingHours[indexToUpdate]?.shifts || [];
                            const mergedShifts = [...oldShifts, newShift];

                            updatedEmployeeWorkingHours[indexToUpdate] = {
                                ...updatedEmployeeWorkingHours[indexToUpdate],
                                dailyWorkingHourId: responseDWH.id,
                                typology: 'turno',
                                time_slots: time_slots,
                                ref_name: responseDWH.ref_name,
                                ref_ou: responseDWH.ref_ou,
                                shifts: sortShiftsByStartTime(mergedShifts),
                            };
                        } else {
                            updatedEmployeeWorkingHours.push({
                                employeeId: selectedEmployee,
                                date: responseDWH.date,
                                dailyWorkingHourId: responseDWH.id,
                                typology: 'turno',
                                time_slots: time_slots,
                                ref_ou: workingHourData.ou,
                                shifts: sortShiftsByStartTime([newShift]),
                            });
                        }

                        // aggiungo il turno tra quelli da confermare
                        newUnconfirmed.push({
                            employeeId: selectedEmployee,
                            dailyWorkingHourId: responseDWH.id,
                        });

                        // notifica per ogni data effettivamente creata
                        const notifDate = moment(responseDWH.date).format('DD/MM/YYYY');
                        newNotifications.push({
                            employeeId: selectedEmployee,
                            title: `Notifica turno - ${selectedEmployeeName}`,
                            message: `Hai un nuovo turno assegnato il ${notifDate}`,
                        });

                        successes.push({ date: dateISO, id: responseDWH.id });

                    } catch (err) {
                        console.error(`Errore nella creazione del turno per la data ${dateISO}`, err);
                        failures.push({
                            date: dateISO,
                            reason: v2EstraiMessaggiErrore(err),
                        });
                        // NON rilancio, così le altre date vengono comunque tentate
                    }
                }

                // aggiorno lo stato *anche se solo alcuni turni sono andati a buon fine*
                setEmployeeWorkingHours(updatedEmployeeWorkingHours);
                setUnconfirmedShiftsIds(newUnconfirmed);
                setNotificationsToSend(newNotifications);

                Swal.close();

                const ok = successes.length;
                const ko = failures.length;

                if (ok && !ko) {
                    // Tutto ok
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "Turno assegnato con successo!",
                        text: `Creati ${ok} turni.`,
                        showConfirmButton: false,
                        timer: 1200,
                    });

                    // reset stato solo in caso di almeno un successo
                    setSelectedOption('');
                    setSelectedWorkingHourId(null);
                    setSelectedWeeklyWorkingHourId(null);
                    setModalOpen(false);
                    if (selectedUnit) setTemporarySelectedUnit(selectedUnit);
                    else setTemporarySelectedUnit('');

                } else if (ok && ko) {
                    // Successo parziale
                    const failureList = failures
                        .map(f => `${moment(f.date).format('DD/MM/YYYY')}: ${f.reason}`)
                        .join('<br/>');

                    Swal.fire({
                        icon: "warning",
                        title: "Assegnazione parziale",
                        html: `Creati <b>${ok}</b> turni.<br/>Non creati: <b>${ko}</b>:<br/>${failureList}`,
                        confirmButtonText: "OK",
                    });

                    // anche qui direi di chiudere la modale, tanto lo stato in tabella è aggiornato
                    setSelectedOption('');
                    setSelectedWorkingHourId(null);
                    setSelectedWeeklyWorkingHourId(null);
                    setModalOpen(false);
                    if (selectedUnit) setTemporarySelectedUnit(selectedUnit);
                    else setTemporarySelectedUnit('');

                } else {
                    // Nessun turno creato
                    const failureList = failures
                        .map(f => `${moment(f.date).format('DD/MM/YYYY')}: ${f.reason}`)
                        .join('<br/>');

                    Swal.fire({
                        icon: "error",
                        title: "Nessun turno creato",
                        html: failureList || 'Errore durante l\'assegnazione del turno.',
                        confirmButtonText: "OK",
                    });
                    // In questo caso NON resetto la modale, così puoi correggere
                }

            } catch (error) {
                console.error('Errore durante l\'assegnazione del turno:', error);
                Swal.close();

                let errorMessage = v2EstraiMessaggiErrore(error);

                Swal.fire({
                    icon: 'error',
                    title: 'Errore',
                    text: errorMessage,
                    confirmButtonText: 'OK',
                });
            }

            return; // evita il ramo "assegna turno esistente"
        }

        // --- caso "assegna turno esistente" (come prima) ---
        let workingHourData;

        // Selezione di una fascia oraria esistente
        const selectedWorkingHour = workingHours.find(wh => wh.id === selectedWorkingHourId);

        if (!selectedWorkingHour) {
            console.error('Fascia oraria non trovata');
            return;
        }

        workingHourData = {
            date: selectedDay,
            working_hour: selectedWorkingHour.id,
            time_slots: [],
            ou: selectedUnit?.id,
            name: selectedUnit?.name,
        };
        
        try {
            if (selectedEmployee !== undefined) {

                Swal.fire({
                    title: 'Assegnazione turno...',
                    icon: 'info',
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
                
                const responseDWH = await createEmployeeWorkingHour(token, selectedEmployee, workingHourData);

                const time_slots = responseDWH.working_hour ? convertWorkingHourToShifts(responseDWH.working_hour, workingHours) : responseDWH.time_slots;
                const isCustom = selectedOption === "CREA FASCIA ORARIA";

                await updateTotalHours();

                const indexToUpdate = employeeWorkingHours.findIndex(entry => entry.employeeId === selectedEmployee && entry.date === responseDWH.date);
                
                const newShift = {
                    ref_name: responseDWH.ref_name,
                    ref_ou: responseDWH.ou,
                    dailyWorkingHourId: responseDWH.id,
                    typology: isCustom ? 'custom' : responseDWH.typology,
                    workingHourId: selectedWorkingHour.id,
                    time_slots: time_slots,
                }

                const updatedEmployeeWorkingHours = [...employeeWorkingHours];
                if (indexToUpdate !== -1) {
                    const oldShifts = updatedEmployeeWorkingHours[indexToUpdate]?.shifts || [];
                    const mergedShifts = [...oldShifts, newShift];

                    updatedEmployeeWorkingHours[indexToUpdate] = {
                        ...updatedEmployeeWorkingHours[indexToUpdate],
                        dailyWorkingHourId: responseDWH.id,
                        typology: 'turno',
                        time_slots: time_slots,
                        ref_name: responseDWH.ref_name,
                        ref_ou: responseDWH.ref_ou,
                        shifts: sortShiftsByStartTime(mergedShifts),
                    };
                } else {
                    updatedEmployeeWorkingHours.push({
                        employeeId: selectedEmployee,
                        date: responseDWH.date,
                        dailyWorkingHourId: responseDWH.id,
                        typology: 'turno',
                        time_slots: time_slots,
                        ref_ou: workingHourData.ou,
                        shifts: sortShiftsByStartTime([newShift]),
                    });
                }

                setEmployeeWorkingHours(updatedEmployeeWorkingHours);

                setUnconfirmedShiftsIds(prevUnconfirmedShiftsIds => [
                    ...prevUnconfirmedShiftsIds, 
                    { employeeId: selectedEmployee, dailyWorkingHourId: responseDWH.id }
                ]);
                
                setNotificationsToSend(prevNotifications => [
                    ...prevNotifications,
                    { employeeId: selectedEmployee, title: `Notifica turno - ${selectedEmployeeName}`, message: `Hai un nuovo turno assegnato il ${formattedDate}` }
                ]);
                
                setSelectedOption('');
                setSelectedWorkingHourId(null);
                setSelectedWeeklyWorkingHourId(null);
                setModalOpen(false);
                if (selectedUnit)
                    setTemporarySelectedUnit(selectedUnit);
                else
                    setTemporarySelectedUnit('');
                Swal.close();
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Turno assegnato con successo!",
                    showConfirmButton: false,
                    timer: 1000,
                });
            } else {
                throw new Error('Nessun dipendente selezionato');
            }
        } catch (error) {
            console.error('Errore durante l\'assegnazione del turno:', error);
            Swal.close();
          
            const errorMessage = getUiErrorMessage(error);
        
            Swal.fire({
                icon: 'error',
                title: 'Errore',
                text: errorMessage,
                confirmButtonText: 'OK',
            });
        }
    };
    
    const handleSaveWeekWorkingHour = async () => {
        try {
            if (!selectedEmployee) {
                throw new Error('Nessun dipendente selezionato');
            }
    
            if (selectedOption !== "CREA FASCIA ORARIA" && !selectedWeeklyWorkingHourId) {
                throw new Error('Nessuna fascia oraria selezionata');
            }
    
            const selectedWeekWorkingHour = weeklyWorkingHours.find(wwh => wwh.id === selectedWeeklyWorkingHourId);
    
            if (!selectedWeekWorkingHour || !selectedWeekWorkingHour.slots_by_weekday) {
                throw new Error('Turno settimanale non trovato o dati incompleti');
            }

            let successes = [];
            let failures = [];

            const startOfWeek = moment(selectedDay).startOf('isoWeek'); // lunedì

            // Tutte le date della settimana (lun-dom)
            const weekDates = [];
            for (let i = 0; i < 7; i++) {
                const currentDay = startOfWeek.clone().add(i, 'days');
                weekDates.push(currentDay.format('YYYY-MM-DD'));
            }

            // 🔹 Filtra solo i giorni in cui il dipendente ha un contratto attivo
            const validWeekDates = weekDates.filter(dateStr => {
                const entry = employeeWorkingHours.find(
                    e => e.employeeId === selectedEmployee && e.date === dateStr
                );
                return entry?.has_active_contract === true;
            });

            // Se nessun giorno è valido, non ha senso procedere
            if (validWeekDates.length === 0) {
                throw new Error('Non ci sono giorni con contratto attivo nella settimana selezionata.');
            }

            let updatedEmployeeWorkingHours = [...employeeWorkingHours];
            const conflictingDates = [];

            // 🔹 Verifica conflitti SOLO sui giorni validi
            for (const dateStr of validWeekDates) {
                const existingEntry = updatedEmployeeWorkingHours.find(
                    entry => entry?.employeeId === selectedEmployee && entry?.date === dateStr
                );

                if (existingEntry) {
                    // Controlla se ci sono turni (shifts) per il giorno e se contengono time_slots
                    const shiftsWithTimeSlots = (existingEntry.shifts || []).filter(
                        (shift) => Array.isArray(shift.time_slots) && shift.time_slots.length > 0
                    );
                    if (shiftsWithTimeSlots.length > 0) {
                        // Aggiungi il giorno ai conflitti
                        conflictingDates.push(dateStr);
                    }
                }
            }

            // Verifica se ci sono turni da sovrascrivere
            let shouldOverride = false;
            if (conflictingDates.length > 0) {
                const result = await Swal.fire({
                    title: 'Turni esistenti trovati',
                    text: `Sono presenti dei turni assegnati nella settimana. Vuoi sovrascriverli con il turno settimanale selezionato?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sì, sovrascrivi',
                    cancelButtonText: 'No, annulla'
                });
    
                if (result.isConfirmed) {
                    shouldOverride = true;
                    Swal.fire({
                        title: 'Assegnazione turno...',
                        icon: 'info',
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });
                } else {
                    return;
                }
            }

            let deletedWorkingHourIds = [];
            let deletedDWHNotifications = {};

            // Elimina turni solo sui giorni validi e confliggenti
            if (shouldOverride) {
                for (const date of conflictingDates) {
                    const existingEntry = updatedEmployeeWorkingHours.find(
                        entry => entry?.employeeId === selectedEmployee && entry?.date === date
                    );

                    if (!existingEntry) continue;

                    try {
                        const shiftsToDelete = (existingEntry.shifts || []).filter(
                            shift =>
                            shift.dailyWorkingHourId ||
                            (Array.isArray(shift.time_slots) && shift.time_slots.length > 0)
                        );

                        for (const shift of shiftsToDelete) {
                            if (shift.dailyWorkingHourId) {
                            await deleteEmployeeDailyWorkingHour(
                                token,
                                selectedEmployee,
                                shift.dailyWorkingHourId
                            );

                            deletedWorkingHourIds.push({
                                employeeId: selectedEmployee,
                                dailyWorkingHourId: shift.dailyWorkingHourId,
                            });

                            // se il turno era confermato, va notificato
                            if (shift.status === true) {
                                deletedDWHNotifications = {
                                    ...deletedDWHNotifications,
                                    [shift.dailyWorkingHourId]: [
                                        selectedEmployee,
                                        moment(date).format('DD/MM/YYYY'),
                                        shift.ref_ou || '',
                                    ],
                                };
                            }
                            }

                            if (Array.isArray(shift.time_slots) && shift.time_slots.length > 0) {
                            shift.time_slots = [];
                            }
                        }

                        updatedEmployeeWorkingHours = updatedEmployeeWorkingHours.map(wh => {
                            if (wh.employeeId === selectedEmployee && wh.date === date) {
                            const updatedShifts = (wh.shifts || []).filter(
                                shift => !shiftsToDelete.includes(shift)
                            );
                            return { ...wh, shifts: updatedShifts };
                            }
                            return wh;
                        });

                        setEmployeeWorkingHours(updatedEmployeeWorkingHours);
                    } catch (error) {
                        console.error(`Errore nell'eliminazione del turno giornaliero per la data ${date}`, error);
                    }
                }
            }

            // Notifica eliminazione di turni confermati (se presente)
            if (Object.keys(deletedDWHNotifications).length > 0) {
                try {
                    await postNotificationDWH(token, { deleted_ids: deletedDWHNotifications });
                } catch (notificationError) {
                    console.error(
                    'Errore durante l\'invio della notifica per turni confermati:',
                    notificationError
                    );
                    Swal.fire({
                        icon: "warning",
                        title: "Attenzione",
                        text: "Alcuni turni confermati sono stati eliminati, ma non è stato possibile inviare la notifica.",
                        confirmButtonText: "OK"
                    });
                }
            }

            // 🔹 aggiorna stato DWH da confermare escludendo quelli eliminati
            setUnconfirmedShiftsIds(prevUnconfirmedShiftsIds =>
                prevUnconfirmedShiftsIds.filter(shift =>
                    !deletedWorkingHourIds.some(deleted =>
                    deleted.employeeId === shift.employeeId &&
                    deleted.dailyWorkingHourId === shift.dailyWorkingHourId
                    )
                )
            );

            const newWorkingHourIds = [];

            // Crea nuovi turni per ciascun giorno valido
            for (const dateStr of validWeekDates) {
                const isoWeekDay = moment(dateStr).isoWeekday(); // 1=lun, 7=dom

                const slot = selectedWeekWorkingHour.slots_by_weekday.find(
                    s => s.week_day === isoWeekDay
                );
                if (!slot) continue;

                // 👇 aggiungi questa riga
                const isSlotWorkingHour = !!(slot.working_hour && slot.working_hour.id);

                let workingHourData = { date: dateStr };

                if (isSlotWorkingHour) {
                    // riferimento a un working_hour esistente
                    workingHourData.working_hour = slot.working_hour.id;
                    workingHourData.time_slots = [];
                    workingHourData.ou = selectedUnit?.id;
                    workingHourData.ou_name = selectedUnit?.name;
                } else if (slot.time_slots) {
                    // slots custom
                    const timeSlotsData = slot.time_slots.map(timeSlot => ({
                        start_at: timeSlot.start_at,
                        end_at: timeSlot.end_at,
                        breaks: (timeSlot.breaks || []).map(b => ({
                            start_at: b.start_at,
                            end_at: b.end_at,
                            is_visible: b.is_visible,
                        })),
                    }));

                    workingHourData.time_slots = timeSlotsData;
                    workingHourData.name = selectedWeekWorkingHour.name;
                    workingHourData.ou = selectedUnit?.id;
                    workingHourData.ou_name = selectedUnit?.name;
                }

                try {
                    const responseDWH = await createEmployeeWorkingHour(
                        token,
                        selectedEmployee,
                        workingHourData
                    );

                    const time_slots = responseDWH.working_hour
                        ? convertWorkingHourToShifts(responseDWH.working_hour, workingHours)
                        : responseDWH.time_slots;

                    const newShift = {
                        dailyWorkingHourId: responseDWH.id,
                        typology: isSlotWorkingHour ? 'working_hour' : 'custom',
                        workingHourId: isSlotWorkingHour
                            ? (slot.working_hour?.id ?? responseDWH.working_hour ?? null)
                            : null,
                        time_slots,
                        name: responseDWH?.name,
                        ref_name: responseDWH?.ref_name,
                        ref_ou: responseDWH?.ou,
                        status: responseDWH?.status ?? false,
                    };

                    updatedEmployeeWorkingHours = updatedEmployeeWorkingHours.map(entry => {
                        if (entry.employeeId === selectedEmployee && entry.date === dateStr) {
                            const existingShifts = entry.shifts || [];
                            const mergedShifts = sortShiftsByStartTime([...existingShifts, newShift]);

                            return {
                                ...entry,
                                shifts: mergedShifts,
                            };
                        }
                        return entry;
                    });

                    successes.push({
                        date: dateStr,
                        id: responseDWH.id,
                    });

                    newWorkingHourIds.push({
                        employeeId: selectedEmployee,
                        dailyWorkingHourId: responseDWH.id,
                    });
                } catch (error) {
                    console.error('Errore nella creazione del turno giornaliero', error);
                    failures.push({
                        date: dateStr,
                        reason: getUiErrorMessage(error),
                    });
                }
            }

            setEmployeeWorkingHours(updatedEmployeeWorkingHours);

            // aggiungi i nuovi turni tra quelli "da confermare" (evitando duplicati)
            setUnconfirmedShiftsIds(prevUnconfirmedShiftsIds => {
                const newShifts = newWorkingHourIds.filter(newShift =>
                    !prevUnconfirmedShiftsIds.some(
                    shift =>
                        shift.employeeId === newShift.employeeId &&
                        shift.dailyWorkingHourId === newShift.dailyWorkingHourId
                    )
                );
                return [...prevUnconfirmedShiftsIds, ...newShifts];
            });

            setSelectedOption('');
            setSelectedWorkingHourId(null);
            setSelectedWeeklyWorkingHourId(null);
            setModalOpen(false);
            setIsLoading(false);

            // 🔹 riepilogo finale
            const ok = successes.length;
            const ko = failures.length;

            Swal.close();
            if (ok && !ko) {
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Turno settimanale assegnato con successo!",
                    text: `Creati ${ok} turni.`,
                    showConfirmButton: false,
                    timer: 1200
                });
            } else if (ok && ko) {
                const failureList = failures
                    .map(f => `${moment(f.date).format('DD/MM/YYYY')}: ${f.reason}`)
                    .join('<br/>');

                Swal.fire({
                    icon: "warning",
                    title: "Assegnazione parziale",
                    html: `Creati <b>${ok}</b> turni.<br/>Saltati <b>${ko}</b>:<br/>${failureList}`,
                    confirmButtonText: "OK"
                });
            } else {
                const failureList = failures
                    .map(f => `${moment(f.date).format('DD/MM/YYYY')}: ${f.reason}`)
                    .join('<br/>');

                Swal.fire({
                    icon: "error",
                    title: "Nessun turno creato",
                    html: failureList || 'Nessun contratto attivo nella settimana selezionata.',
                    confirmButtonText: "OK"
                });
            }
        } catch (error) {
            console.error('Errore nella creazione del turno settimanale', error);
            Swal.close();

            const backendMessage = v2EstraiMessaggiErrore?.(error) || error.message || 'Errore sconosciuto';
            Swal.fire('Errore...', backendMessage, 'error');
        }
    };


    const toggleNotificationSelection = (employeeId) => {
        setSelectedNotifications((prevSelected) =>
            prevSelected.includes(employeeId)
                ? prevSelected.filter((id) => id !== employeeId)
                : [...prevSelected, employeeId]
        );
    };
    
    const handleDeleteDailyWh = async (employeeId, dailyWhId, cf, formattedDay, employeeLN, employeeFN, shiftStatus, dwhRefOu) => {        
        if (profile.customer_type !== 'employee' || 
            profile.employee?.permissions.includes('hr.manage_shifts_all') || 
            profile.employee?.permissions.includes('hr.manage_shifts_ou')) {           
                
            const day = moment(formattedDay).format('DD/MM/YYYY');  
            setSelectedDay(day);

            const fullName = (employeeLN && employeeFN) 
                ? `${employeeLN} ${employeeFN}`.trim() 
                : cf;
            
            setSelectedEmployeeName(fullName);

            const currentEmployee = employeesWithActiveContract.find(employee => employee.id === employeeId);
            const employeeCalendarData = employeesCalendarData.find(data => data.id === employeeId);
            const typology = employeeCalendarData ? employeeCalendarData.typology : null;
        
            if (typology === 'fisso') {
                Swal.fire({
                    icon: 'info',
                    title: 'Turno Fisso',
                    text: 'Il dipendente selezionato ha il contratto con turno fisso e può essere eliminato nella sezione anagrafica',
                    showCancelButton: true,
                    confirmButtonText: 'Vai all\'anagrafica',
                    cancelButtonText: 'Annulla',
                    cancelButtonColor: '#d1d5db',
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.href = `/dipendenti/${cf}/edit?tab=4`;
                    }
                });
                return;
            }

            const confirmationMessage = shiftStatus 
            ? "Confermando, verrà eliminato il turno di lavoro selezionato e notificata l'azione al dipendente e gestori, se presenti."
            : "Questa azione eliminerà il turno di lavoro selezionato";

            Swal.fire({
                title: 'Confermi l\'eliminazione?',
                text: confirmationMessage,
                icon: 'warning',
                showCancelButton: true,
                cancelButtonColor: '#cbd5e1',
                cancelButtonText: 'Annulla',
                confirmButtonText: 'Sì, elimina!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        Swal.fire({
                            title: 'Eliminazione in corso...',
                            icon: 'info',
                            showConfirmButton: false,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            didOpen: () => {
                                Swal.showLoading();
                            }
                        });

                        const employeeWorkingHour = employeeWorkingHours.find(wh => wh.employeeId === employeeId);
                        let deletedWorkingHourIds = [];
                        const deletedDailyWh = employeeWorkingHour 
                            ? employeeWorkingHour.shifts.find(shift => shift.dailyWorkingHourId === dailyWhId) 
                            : null;
                        
                        await deleteEmployeeDailyWorkingHour(token, employeeId, dailyWhId);
                        await refreshEmployeeDay(employeeId, moment(formattedDay).format('YYYY-MM-DD'));

                        setUnconfirmedShiftsIds(prevUnconfirmedShifts =>
                            prevUnconfirmedShifts.filter(shift => !(shift.employeeId === employeeId && shift.dailyWorkingHourId === dailyWhId))
                        );

                        await updateTotalHours();
                    
                        Swal.close();
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Turno di lavoro eliminato con successo!",
                            showConfirmButton: false,
                            timer: 1000,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });


                    if (shiftStatus) {
                        try {
                            const data = [
                                dailyWhId || '',
                                employeeId || '',
                                moment(formattedDay).format('DD/MM/YYYY') || '',
                                dwhRefOu || '',
                            ];
                            
                            const formattedData = {
                                [data[0]]: [data[1], data[2], data[3]],
                            };

                            // await postNotificationDWH(token, data);
                            await postNotificationDWH(token, {
                                deleted_ids: formattedData
                            });

                        } catch (notificationError) {
                            console.error('Errore durante l\'invio della notifica:', notificationError);
                            Swal.fire({
                                icon: "warning",
                                title: "Attenzione",
                                text: "Il turno è stato eliminato, ma non è stato possibile inviare la notifica al dipendente.",
                                confirmButtonText: "OK"
                            });
                        }
                    }

                } catch (error) {
                    console.error('Errore durante l\'eliminazione del turno di lavoro:', error);
                    Swal.close();
                    Swal.fire('Errore...', 'Si è verificato un errore durante l\'eliminazione del turno di lavoro', 'error');
                }
                }
            });
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Non hai i permessi per eseguire questa azione',
                confirmButtonText: 'OK'
            });
        }
    };

    const handleEditOuPairing = (dipendente, dailyWh) => {
        if (profile.customer_type !== 'employee' || 
            profile.employee?.permissions.includes('hr.manage_shifts_all') || 
            profile.employee?.permissions.includes('hr.manage_shifts_ou')) { 

            setSelectedDWH({ employee: dipendente, dailyWh: dailyWh });
            setIsModalOuPairingOpen(true);
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Non hai i permessi per eseguire questa azione',
                confirmButtonText: 'OK'
            });
        }
    };

    const closeModalPairingOuDWH = () => {
        setIsModalOuPairingOpen(false);
        setSelectedDWH(null);
    };

    const handleSelectOUtoPair = async (selectedUnit, dailyWhId, employeeId) => {
        try {
            // loader
            Swal.fire({
                title: 'Aggiornamento in corso...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => Swal.showLoading(),
            });

            const updatedData = await updateEmployeeDWHOuPair(
                token,
                employeeId,
                dailyWhId,
                selectedUnit ? selectedUnit.id : null
            );
            
            const dateFromResponse = updatedData?.date || selectedDay;
            
            await refreshEmployeeDay(employeeId, dateFromResponse);

            await updateTotalHours?.();

            Swal.close();
            Swal.fire({
                icon: 'success',
                title: 'Unità collegata al turno',
                timer: 1200,
                showConfirmButton: false,
            });

            setIsModalOuPairingOpen(false);
            setSelectedDWH(null);
        } catch (error) {
            console.error('Failed to update:', error);
            Swal.close();
            const msg = v2EstraiMessaggiErrore(error);
            Swal.fire({
                icon: 'error',
                title: 'Errore',
                text: msg,
                confirmButtonText: 'OK',
            });
            // QUI non chiudo la modale così l’utente può riprovare
            // quindi niente setIsModalOuPairingOpen(false) qui
        }
    };
    
    // non eliminare altrimenti non funziona assegnazione turno
    const handleSelectWorkingHour = (selected) => {    
        if (!selected) {
          return;
        }
        setSelectedWorkingHourId(selected.id);
    };

    useEffect(() => {
        setSelectedWorkingHourId(null);
        setSelectedWeeklyWorkingHourId(null);
      }, [selectedOption]);

    const handleToggleChange = (selectedOption) => {
        setSelectedOption(selectedOption);
    };

    const handleCloseModal = () => {
        setSelectedOption('');
        setSelectedWorkingHourId(null);
        setSelectedWeeklyWorkingHourId(null);
        setModalOpen(false);
    };

    const calculateTotalHours = (shifts) => {
        let totalMinutes = 0;
        
        shifts.forEach((shift) => {
            if (Array.isArray(shift.time_slots)) {
                shift.time_slots.forEach((slot) => {
                    const durationInMinutes = slot.duration || 0;
        
                    if (typeof durationInMinutes === 'number' && durationInMinutes >= 0) {
                        totalMinutes += durationInMinutes;
                    } else {
                        console.error('Invalid duration found in time slot:', slot);
                    }
                });
            }
        });
    
        const totalHours = Math.floor(totalMinutes / 60);
        const remainingMinutes = totalMinutes % 60;
        
        if (totalHours > 0 && remainingMinutes > 0) {
            return `${totalHours} h, ${remainingMinutes} min`;
        } else if (totalHours > 0) {
            return `${totalHours} h`;
        } else if (remainingMinutes > 0) {
            return `${remainingMinutes} min`;
        } else {
            return ``;
        }
    };
    
    const calculateWeeklyTotalMinutes = (employeeWorkingHours) => {
        let weeklyTotalMinutes = 0;
    
        employeeWorkingHours.forEach((day) => {
            if (Array.isArray(day.shifts)) {
                const dailyTotalMinutes = day.shifts.reduce((totalMinutes, shift) => {
                    if (Array.isArray(shift.time_slots)) {
                        const shiftTotalMinutes = shift.time_slots.reduce((slotMinutes, slot) => {
                            const durationInMinutes = slot.duration || 0;
    
                            return slotMinutes + (typeof durationInMinutes === 'number' && durationInMinutes >= 0 ? durationInMinutes : 0);
                        }, 0);
    
                        return totalMinutes + shiftTotalMinutes;
                    }
                    return totalMinutes;
                }, 0);
                weeklyTotalMinutes += dailyTotalMinutes;
            }
        });
    
        return weeklyTotalMinutes;
    };
    
    const formatMinutesToHours = (totalMinutes) => {
        const totalHours = Math.floor(totalMinutes / 60);
        const remainingMinutes = Math.round(totalMinutes % 60);
        
        if (totalHours > 0 && remainingMinutes > 0) {
            return `${totalHours} H, ${remainingMinutes} MIN`;
        } else if (totalHours > 0) {
            return `${totalHours} H`;
        } else if (remainingMinutes > 0) {
            return `${remainingMinutes} MIN`;
        } else {
            return `0`;
        }
    };    

    const handleInfoEmloyeeFisso = (id, cf) => {
        Swal.fire({
            icon: 'info',
            title: 'Turno Fisso',
            text: 'Il dipendente ha un turno fisso. Eventuali modifiche del turno assegnato possono essere effettuate nell\'anagrafica',
            showCancelButton: true,
            confirmButtonText: 'Vai all\'anagrafica',
            cancelButtonText: 'Annulla',
            cancelButtonColor: '#d1d5db',
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.href = `/dipendenti/${cf}/edit?tab=4`;
            }
        });
    };

    const handleSelectUnit = (selected) => {
        const unit = selected === 'all' || !selected ? null : selected;
        setSelectedUnit(unit);
    };

    const handleResetUnitSelection = () => {
        setSelectedUnit(null);
    };

    const handleResetOUtoPairSelection = () => {
        setSelectedOuToPair(null);
    };

    const handleConfirmSingleShift = async (employee, dailyWorkingHourId) => {
        if (!canManageShifts) {
            Swal.fire({
                icon: 'warning',
                title: 'Non hai i permessi per eseguire questa azione',
                confirmButtonText: 'OK',
            });
            return;
        }

        const employeeId = employee.id;
        let confirmedOk = false;

        try {
            Swal.fire({
                title: 'Conferma in corso...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => Swal.showLoading(),
            });

            await updateEmployeeWorkingHourStatus(token, employeeId, dailyWorkingHourId);
            confirmedOk = true;

            await updateTotalHours();

            setEmployeeWorkingHours(prev =>
                prev.map(emp => ({
                    ...emp,
                    shifts: emp.shifts.map(shift =>
                    shift.dailyWorkingHourId === dailyWorkingHourId
                        ? { ...shift, status: true }
                        : shift
                    ),
                }))
            );

            setUnconfirmedShiftsIds(prev =>
                prev.filter(
                    s => !(s.employeeId === employeeId && s.dailyWorkingHourId === dailyWorkingHourId)
                )
            );

            Swal.close();
            Swal.fire({
                title: 'Turno confermato!',
                icon: 'success',
                timer: 1500,
                showConfirmButton: false,
            });
        } catch (error) {
            const errorMessage = v2EstraiMessaggiErrore(error);
            Swal.close();
            Swal.fire({
                title: 'Errore!',
                text: errorMessage,
                icon: 'error',
                confirmButtonText: 'OK',
            });
        }

        if (confirmedOk) {
            try {
                await postNotificationDWH(token, { approved_ids: [dailyWorkingHourId] });
            } catch (notificationError) {
                console.error('Errore nell’invio della notifica:', notificationError);
                Swal.fire({
                    icon: 'warning',
                    title: 'Attenzione',
                    text:
                    'Il turno è stato confermato, ma non è stato possibile inviare la notifica al dipendente.',
                    confirmButtonText: 'OK',
                });
            }
        }
    };
    

    const handleConfirmShifts = () => {
        if (!canManageShifts) {
            Swal.fire({
            icon: 'warning',
            title: 'Non hai i permessi per eseguire questa azione',
            confirmButtonText: 'OK',
            });
            return;
        }

        Swal.fire({
            title: 'Stai confermando i turni',
            text: `Confermi la pubblicazione di ${unconfirmedShiftsIds.length} turni? L'azione verrà notificata ${unconfirmedShiftsIds.length > 1 ? 'ai dipendenti' : 'al dipendente'} e gestori, se presenti.`,
            icon: 'warning',
            showCancelButton: true,
            cancelButtonColor: '#cbd5e1',
            confirmButtonText: 'Conferma',
            cancelButtonText: 'Annulla',
        }).then((result) => {
            if (result.isConfirmed) {
                publishShifts(unconfirmedShiftsIds);
            }
        });
    };

    const publishShifts = async (unconfirmed) => {
        if (!Array.isArray(unconfirmed) || unconfirmed.length === 0) return;

        let blockedShiftsCount = 0;
        const validShifts = unconfirmed.filter((shift) => {
            const shiftDate = new Date(shift.shiftDays);
            const month = shiftDate.getMonth() + 1;
            const year = shiftDate.getFullYear();
            const isBlocked = blockedMonths.some((m) => m.month === month && m.year === year);
            if (isBlocked) blockedShiftsCount++;
            return !isBlocked;
        });

        if (validShifts.length === 0) {
            Swal.fire({
                title: 'Nessun turno disponibile',
                text: 'Tutti i turni selezionati appartengono a mesi bloccati. Non è possibile confermare i turni.',
                icon: 'warning',
                confirmButtonText: 'OK',
            });
            return;
        }

        Swal.fire({
            title: 'Conferma in corso...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
            showConfirmButton: false,
        });

        const approvedIds = [];
        const failed = []; // {id, errorMessage}

        try {
            // 3) esegui tutte le conferme, catturando errori singoli
            const results = await Promise.allSettled(
            validShifts.map(async ({ employeeId, dailyWorkingHourId }) => {
                try {
                await updateEmployeeWorkingHourStatus(token, employeeId, dailyWorkingHourId);
                return { ok: true, id: dailyWorkingHourId };
                } catch (err) {
                return { ok: false, id: dailyWorkingHourId, err };
                }
            })
            );

            // 4) split success / error
            results.forEach((res) => {
            if (res.status === 'fulfilled') {
                if (res.value.ok) approvedIds.push(res.value.id);
                else failed.push({
                id: res.value.id,
                errorMessage: v2EstraiMessaggiErrore(res.value.err),
                });
            } else {
                // allSettled rejected (improbabile, ma gestiamo)
                failed.push({
                id: null,
                errorMessage: v2EstraiMessaggiErrore(res.reason),
                });
            }
            });

            // 5) aggiorna stato UI solo per i turni davvero confermati
            if (approvedIds.length > 0) {
            setEmployeeWorkingHours((prev) =>
                prev.map((emp) => ({
                ...emp,
                shifts: emp.shifts.map((shift) =>
                    approvedIds.includes(shift.dailyWorkingHourId)
                    ? { ...shift, status: true }
                    : shift
                ),
                }))
            );

            setUnconfirmedShiftsIds((prev) =>
                prev.filter(({ dailyWorkingHourId }) => !approvedIds.includes(Number(dailyWorkingHourId)))
            );
            }

            Swal.close();

            // 6) messaggi finali
            const partialBlockedMsg =
            blockedShiftsCount > 0
                ? ` Alcuni turni appartenevano a mesi bloccati e non sono stati confermati.`
                : '';

            if (failed.length === 0 && approvedIds.length > 0) {
            Swal.fire({
                title: 'Turni confermati!',
                text: `${approvedIds.length} turni confermati.${partialBlockedMsg}`,
                icon: 'success',
                showConfirmButton: false,
                timer: 1500,
            });
        } else if (approvedIds.length > 0 && failed.length > 0) {
            // parziale: mostra riepilogo errori
            const errorList = failed
                .map((f, i) => `• ${i + 1}: ${f.errorMessage}`)
                .join('\n');

            Swal.fire({
                icon: 'warning',
                title: 'Conferma parziale',
                html:
                `<p>Sono stati confermati ${approvedIds.length} turni.${partialBlockedMsg || ''}</p>` +
                (failed.length
                    ? `<p style="margin-top:8px; margin-bottom:8px">
                        <strong>Error${failed.length === 1 ? 'e' : 'i'} per ${failed.length} turn${failed.length === 1 ? 'o' : 'i'}:</strong>
                    </p>` +
                    `<pre style="
                        text-align:left;
                        white-space:pre-wrap;
                        word-break:break-word;
                        font-family: inherit;
                        font-size: 12px;
                        color: inherit;
                        background:#f3f4f6;
                        padding:8px;
                        border-radius:6px;
                        max-height:220px;
                        overflow:auto;
                    ">${errorList}</pre>`
                    : ''
                ),
                confirmButtonText: 'OK',
            });
        
            } else {
                // tutto fallito
                const errorList = failed
                    .map((f, i) => `• ${i + 1}: ${f.errorMessage}`)
                    .join('\n');

                    Swal.fire({
                        icon: 'error',
                        title: 'Nessun turno confermato',
                        html:
                            (partialBlockedMsg ? `<p>${partialBlockedMsg}</p>` : '') +
                            `<p style="margin-top:8px; margin-bottom:8px"><strong>Errori:</strong></p>` +
                            `<pre style="
                                text-align:left;
                                white-space:pre-wrap;
                                word-break:break-word;
                                font-family: inherit;
                                font-size: 12px;
                                color: inherit;
                                background:#f3f4f6;
                                padding:8px;
                                border-radius:6px;
                                max-height:220px;
                                overflow:auto;
                            ">${errorList}</pre>`,
                        confirmButtonText: 'OK',
                });
            }
        } catch (err) {
            // errore imprevisto globale
            Swal.close();
            Swal.fire({
            title: 'Errore!',
            text: v2EstraiMessaggiErrore(err),
            icon: 'error',
            confirmButtonText: 'OK',
            });
        }

        // invia notifiche SOLO per quelli approvati
        if (approvedIds.length > 0) {
            try {
            await postNotificationDWH(token, { approved_ids: approvedIds });
            } catch (notifyErr) {
            Swal.fire({
                title: 'Errore di notifica',
                text: 'I turni sono stati confermati, ma non è stato possibile inviare la notifica.',
                icon: 'warning',
                confirmButtonText: 'OK',
            });
            }
        }
    };


    const openModalAddGiustificativo = (dipendente, formattedDay, attendanceForDay) => {
        if (!canManageJustifications) {
            Swal.fire({
                icon: "warning",
                title: "Non hai i permessi per eseguire questa azione",
                confirmButtonText: "OK",
            });
            return;
        }

        if (isDayBlocked(formattedDay)) {
            Swal.fire({
                icon: "error",
                title: "Il giorno è bloccato",
                text: "Non è possibile gestire i giustificativi.",
                confirmButtonText: "OK",
            });
            return;
        }

        setSelectedEmployee(dipendente);
        setSelectedDay(formattedDay);
        setShowModalAddGiustificativo(true);
    };

    const refreshEmployeeDay = async (employeeId, dateISO) => {
        try {
            const res = await getCalendarWorkingHour(
                token,
                { startDate: dateISO, endDate: dateISO },
                selectedUnit?.id,
                [employeeId],
                null,
                null,
                undefined,
                'shifts'
            );

            const payload = res?.data ?? res;
            const emp = payload?.results?.[0];   // un solo dipendente

            setEmployeeWorkingHours((prev) => {
            // tolgo il vecchio giorno di quel dipendente
            const withoutDay = prev.filter(
                (wh) => !(wh.employeeId === employeeId && wh.date === dateISO)
            );

            if (!emp) return withoutDay;

            const newEntries = (emp.days || []).map((day) => {
                const date = day.date;

                const shifts = (day.shifts || []).map((s) => ({
                    ref_name: s.ref_name ?? day.ref_name,
                    ref_ou: s.ref_ou ?? day.ref_ou,
                    dailyWorkingHourId: s.daily_working_hour ?? s.id ?? day.daily_working_hour ?? null,
                    typology: s.typology ?? day.typology,
                    // 🔹 questo è l'id del WORKING HOUR modello (quello che passi come "working_hour")
                    workingHourId: s.ref_id ?? null,
                    time_slots: s.time_slots || day.time_slots || [],
                    status: s.status,
                }));

                return {
                    employeeId: emp.id,
                    date,
                    has_active_contract: day.has_active_contract,
                    has_justifications: day.has_justifications,
                    week_hours: day.week_hours,
                    shift_type: day.shift_type,
                    ref_ou: day.ref_ou ?? null,
                    shifts,
                    typology: emp.typology,
                    justification_requests: emp.justification_requests,
                };
            });

            return [...withoutDay, ...newEntries];
            });
        } catch (err) {
            console.error("Errore durante il refresh del giorno:", err);
        }
    };

    // 1) quando comincio a trascinare UN turno
    const handleShiftDragStart = (event, dipendente, formattedDay, shift) => {
        // se non è attiva nessuna modalità non devo poter trascinare
        if (!dragMode) {
            event.preventDefault();
            return;
        }

        // se c'è un'unità selezionata, permetto il drag SOLO se il turno appartiene a quella unità
        // - se shift.ref_ou è null/undefined → BLOCCO
        // - se shift.ref_ou è diverso da selectedUnit.id → BLOCCO
        if (
            selectedUnit?.id &&
            String(shift.ref_ou || "") !== String(selectedUnit.id)
        ) {
            event.preventDefault();

            Swal.fire({
                icon: "warning",
                title: "Unità non compatibile",
                text: "Non puoi spostare o duplicare questo turno perché non appartiene all'unità selezionata.",
                confirmButtonText: "OK",
            });

            return;
        }


        setDragSource({
            employeeId: dipendente.id,
            date: formattedDay,
            dailyWorkingHourId: shift.dailyWorkingHourId,
            shift,
        });

        event.dataTransfer.effectAllowed = 'copyMove';
    };

    // 2) necessario per permettere il drop
    const handleCellDragOver = (event) => {
        event.preventDefault();
    };

    // 3) quando rilascio il turno in un’altra cella
    const handleCellDrop = async (event, targetDipendenteId, targetDate) => {
        event.preventDefault();

        if (!canManageShifts) {
            Swal.fire({
            icon: "warning",
            title: "Non hai i permessi per eseguire questa azione",
            confirmButtonText: "OK",
            });
            return;
        }

        if (!dragMode) return;

        if (!dragSource) return;
        if (isShiftOperationRunning) return;

        const {
            shift,
            employeeId: sourceEmployeeId,
            date: sourceDate,
            dailyWorkingHourId,
        } = dragSource;

        const baseName = stripUnitaFromName(shift.ref_name || '');
        const isWorkingHour = !!shift.workingHourId;

        // se modalità move e rilascio nella stessa cella → non fare nulla
        if (
            dragMode === "move" &&
            sourceEmployeeId === targetDipendenteId &&
            sourceDate === targetDate
        ) {
            setDragSource(null);
            return;
        }

        setIsShiftOperationRunning(true);
        const targetOuId = shift?.ref_ou ?? selectedUnit?.id ?? null;
        try {
            let workingHourData;

            if (isWorkingHour) {
            // COPIA / SPOSTA come working_hour esistente
            workingHourData = {
                date: targetDate,
                working_hour: shift?.workingHourId,
                time_slots: [],
                ou: targetOuId,
                name: baseName,
            };
            } else {
            // COPIA / SPOSTA come custom (time_slots pieni)
            const timeSlotsData = (shift.time_slots || []).map((ts) => ({
                start_at: ts.start_at,
                    end_at: ts.end_at,
                    breaks: (ts.breaks || []).map((b) => ({
                        start_at: b.start_at,
                        end_at: b.end_at,
                        is_visible: b.is_visible,
                })),
                name: baseName,
            }));

            workingHourData = {
                date: targetDate,
                working_hour: null,
                time_slots: timeSlotsData,
                ou: targetOuId,
                name: baseName,
                typology: "custom",
            };
            }

            // 1) creo il nuovo turno sulla cella target
            const responseDWH = await createEmployeeWorkingHour(
                token,
                targetDipendenteId,
                workingHourData
            );

            // 2) se modalità MOVE → cancello silenziosamente l'origine
            if (dragMode === "move") {
                await silentDeleteDailyWorkingHour(sourceEmployeeId, dailyWorkingHourId, {
                    formattedDay: sourceDate,
                    shiftStatus: shift.status,
                    dwhRefOu: shift.ref_ou || null,
                });
            }

            // 3) refresh lato target
            await refreshEmployeeDay(targetDipendenteId, responseDWH.date);

            // 4) refresh lato source (solo se spostamento e cella diversa)
            if (
                dragMode === "move" &&
                (sourceEmployeeId !== targetDipendenteId ||
                    sourceDate !== responseDWH.date)
            ) {
            await refreshEmployeeDay(sourceEmployeeId, sourceDate);
            }

            // 5) metto il nuovo turno tra quelli da confermare
            setUnconfirmedShiftsIds((prev) => [
                ...prev,
                {
                    employeeId: targetDipendenteId,
                    dailyWorkingHourId: responseDWH.id,
                },
            ]);

            // 6) notifica assegnazione
            setNotificationsToSend((prev) => [
                ...prev,
                {
                    employeeId: targetDipendenteId,
                    title: `Notifica turno - ${shift.ref_name || ""}`,
                    message: `Hai un nuovo turno assegnato il ${moment(
                    responseDWH.date
                    ).format("DD/MM/YYYY")}`,
                },
            ]);

            // 7) ricalcolo totali settimanali
            await updateTotalHours?.();

        } catch (err) {
            console.error("Errore durante duplicazione/spostamento turno:", err);
            const backendMessage =
            v2EstraiMessaggiErrore?.(err) || err.message || "Errore sconosciuto";
            Swal.fire("Errore...", backendMessage, "error");
        } finally {
            setDragSource(null);
            setIsShiftOperationRunning(false);
        }
    };

    const silentDeleteDailyWorkingHour = async (
        employeeId,
        dailyWhId,
        {
            formattedDay,   // "YYYY-MM-DD"
            shiftStatus,    // boolean - turno confermato sì/no
            dwhRefOu,       // OU del daily working hour
        } = {}
    ) => {
        try {
            await deleteEmployeeDailyWorkingHour(token, employeeId, dailyWhId);

            // rimuovo il turno dallo stato locale
            await refreshEmployeeDay(
                employeeId,
                moment(formattedDay).format("YYYY-MM-DD")
            );

            // rimuovo anche dall'elenco dei turni da confermare
            setUnconfirmedShiftsIds(prev =>
                prev.filter(
                    s => !(s.employeeId === employeeId && s.dailyWorkingHourId === dailyWhId)
                )
            );

            // aggiorno i totali settimanali
            await updateTotalHours?.();
            // se il turno era confermato, invio la notifica come in handleDeleteDailyWh
            if (shiftStatus) {
                try {
                    const dayStr = moment(formattedDay).format("DD/MM/YYYY");

                    const data = [
                        dailyWhId || '',
                        employeeId || '',
                        dayStr || '',
                        dwhRefOu || '',
                    ];

                    const formattedData = {
                    [data[0]]: [data[1], data[2], data[3]],
                    };

                    await postNotificationDWH(token, {
                    deleted_ids: formattedData,
                    });
                } catch (notificationError) {
                    console.error(
                    "Errore durante l'invio della notifica (silent delete):",
                    notificationError
                    );
                }
            }
        } catch (err) {
            console.error("Errore durante eliminazione silenziosa DWH:", err);
        }
    };

    const areAllExpanded =
    selectedEmployees.length > 0 &&
    selectedEmployees.every(emp => expandedRows[emp.id]);

    const toggleRow = (employeeId) => {
        setExpandedRows(prev => {
            const next = { ...prev };

            if (next[employeeId]) {
                // se era aperto → chiudi
                delete next[employeeId];
            } else {
                // se era chiuso → apri
                next[employeeId] = true;
            }

            return next;
        });
    };

    const handleToggleExpandAll = () => {
        setExpandAllRows(prev => {
            const newVal = !prev;

            if (newVal) {
                const allExpanded = {};
                getToggleTargetEmployees().forEach(emp => {
                    allExpanded[emp.id] = true;
                });
                setExpandedRows(allExpanded);
                setShowTurniFissi(true);
                setShowTurniVariabili(true);
            } else {
                setExpandedRows({});

                setShowTurniFissi(false);
                setShowTurniVariabili(false);
            }

            return newVal;
        });
    };

    const getToggleTargetEmployees = () => {
        return selectedEmployees.filter(employee =>
            selectedActiveContractEmployees.length === 0 ||
            selectedActiveContractEmployees.some(sel => sel.id === employee.id)
        );
    };

    useEffect(() => {
        // quando cambia la lista dei dipendenti selezionati
        // ricalcolo quali righe devono essere aperte
        setExpandedRows(() => {
            const updated = {};

            const targetEmployees = getToggleTargetEmployees();

            targetEmployees.forEach(emp => {
                const shiftType = (emp.shift_type || '').toLowerCase().trim();

                const isFisso =
                    showTurniFissi && shiftType === 'fisso';

                const allowedVariabili = ['turno', 'a_chiamata'];
                const isVariabile =
                    showTurniVariabili && allowedVariabili.includes(shiftType);

                const isAll = expandAllRows;

                if (isAll || isFisso || isVariabile) {
                    updated[emp.id] = true;
                }
            });

            return updated;
        });
    }, [
        selectedEmployees,
        selectedActiveContractEmployees,
        showTurniFissi,
        showTurniVariabili,
        expandAllRows,
    ]);

    const handleToggleTurniFissi = () => {
        setShowTurniFissi(prev => {
            const next = !prev;

            setExpandedRows(prevExpanded => {
                const updated = { ...prevExpanded };

                getToggleTargetEmployees().forEach(emp => {
                    const shiftType = emp.shift_type;
                    if (shiftType === 'fisso') {
                        if (next) {
                            updated[emp.id] = true;
                        } else {
                            delete updated[emp.id];
                        }
                    }
                });
                
                const allExpanded =
                    selectedEmployees.length > 0 &&
                    selectedEmployees.every(emp => updated[emp.id]);
                setExpandAllRows(allExpanded);

                return updated;
            });

            return next;
        });
    };

    const handleToggleTurniVariabili = () => {
        setShowTurniVariabili(prev => {
            const next = !prev;

            setExpandedRows(prevExpanded => {
                const updated = { ...prevExpanded };

                getToggleTargetEmployees().forEach(emp => {
                    const shiftType = emp.shift_type;
                    const allowed = ['turno', 'a_chiamata'];
                    if (allowed.includes(shiftType)) {
                        if (next) {
                            updated[emp.id] = true;
                        } else {
                            delete updated[emp.id];
                        }
                    }
                });

                const allExpanded =
                    selectedEmployees.length > 0 &&
                    selectedEmployees.every(emp => updated[emp.id]);
                setExpandAllRows(allExpanded);

                return updated;
            });

            return next;
        });
    };

    const handleToggleBreaks = () => {
        setShowBreaks((prev) => {
            const next = !prev;

            if (next) {
                setShowWorkingAreas(false);
            }

            return next;
        });
    };

    const handleToggleWorkingAreas = () => {
        setShowWorkingAreas(prev => {
            const next = !prev;

            if (next) {
                setShowBreaks(false);

                const allExpanded = {};
                getToggleTargetEmployees().forEach(emp => {
                    allExpanded[emp.id] = true;
                });

                setExpandedRows(allExpanded);
                setExpandAllRows(true);
                setShowTurniFissi(true);
                setShowTurniVariabili(true);
            }

            return next;
        });
    };
    
    const openWorkingAreaModal = (employee, day) => {
        if (!(canManageWorkingAreas || canViewWorkingAreas)) {
            Swal.fire({
                icon: "warning",
                title: "Non hai i permessi per eseguire questa azione",
                confirmButtonText: "OK",
            });
            return;
        }

        if (isDayBlocked(day)) {
            Swal.fire({
                icon: "error",
                title: "Il giorno è bloccato",
                text: "Non è possibile associare un’area di lavoro.",
                confirmButtonText: "OK",
            });
            return;
        }

        setSelectedWorkingAreaEmployee(employee);
        setSelectedWorkingAreaDay(day);
        setWorkingAreaModalOpen(true);
    };

    const closeWorkingAreaModal = () => {
        setWorkingAreaModalOpen(false);
        setSelectedWorkingAreaEmployee(null);
        setSelectedWorkingAreaDay(null);
    };

    const handleSwitchWorkingAreaToJustification = (day) => {
        if (!canManageJustifications) {
            Swal.fire({
                icon: "warning",
                title: "Non hai i permessi per eseguire questa azione",
                confirmButtonText: "OK",
            });
            return;
        }

        if (isDayBlocked(day)) {
            Swal.fire({
                icon: "error",
                title: "Il giorno è bloccato",
                text: "Non è possibile gestire i giustificativi.",
                confirmButtonText: "OK",
            });
            return;
        }

        if (!selectedWorkingAreaEmployee) return;

        // trasferisco dipendente + GIORNO ATTUALMENTE VISUALIZZATO
        setSelectedEmployee(selectedWorkingAreaEmployee);
        setSelectedDay(day);

        // chiudo area e apro giustificativi
        setWorkingAreaModalOpen(false);
        setShowModalAddGiustificativo(true);
    };

    const handleSwitchJustificationToWorkingArea = (day) => {
        if (!(canManageWorkingAreas || canViewWorkingAreas)) {
            Swal.fire({
                icon: "warning",
                title: "Non hai i permessi per eseguire questa azione",
                confirmButtonText: "OK",
            });
            return;
        }

        if (isDayBlocked(day)) {
            Swal.fire({
                icon: "error",
                title: "Il giorno è bloccato",
                text: "Non è possibile associare un’area di lavoro.",
                confirmButtonText: "OK",
            });
            return;
        }

        if (!selectedEmployee) return;

        // trasferisco dipendente + GIORNO ATTUALMENTE VISUALIZZATO
        setSelectedWorkingAreaEmployee(selectedEmployee);
        setSelectedWorkingAreaDay(day);

        // chiudo giustificativi e apro area
        setShowModalAddGiustificativo(false);
        setWorkingAreaModalOpen(true);
    };

    const handleWorkingAreaChange = useCallback(
        async ({ employeeId, date }) => {
            if (!employeeId || !date) return;

            await refreshEmployeeDay(
                Number(employeeId),
                moment(date).format("YYYY-MM-DD")
            );
        },
        [refreshEmployeeDay]
    );

    const handleBulkWorkingAreaChange = useCallback(
        async () => {
            await loadCalendar();
        },
        [loadCalendar]
    );

    // const handleEditDailyWh = (employeeId: number, selectedDay: string, dailyWorkingHourId: number) => {
    //     setSelectedDailyWh(dailyWorkingHourId);
    //     setSelectedDay(selectedDay);  
    //     setModalEditDailyWhOpen(true);
    //     setEmployeeEditDailyWh(employeeId); 
    // };

    // const handleEditDailyWhCloseModal = () => {
    //     setModalEditDailyWhOpen(false);
    //     setSelectedShift(null);
    //     setSelectedDay(null);
    // };



    // if(isLoading)
    //     return (
    //         <div className='w-full'>
    //             <Fetching />
    //         </div>
    //     );


    const workingHoursByEmployeeId = useMemo(() => {
        const map = new Map();
        employeeWorkingHours.forEach(wh => {
            if (!map.has(wh.employeeId)) map.set(wh.employeeId, []);
            map.get(wh.employeeId).push(wh);
        });
        return map;
    }, [employeeWorkingHours]);

    const horizontalScrollRef = useRef(null);

    const horizontalPanRef = useRef({
        active: false,
        dragging: false,
        startX: 0,
        startY: 0,
        startScrollLeft: 0,
        pointerId: null,
    });

    const suppressNextTableClickRef = useRef(false);

    const PAN_THRESHOLD = 6;

    const isHorizontalPanExcludedTarget = (target) => {
        if (!(target instanceof HTMLElement)) {
            return false;
        }

        return Boolean(
            target.closest(`
                button,
                a,
                input,
                select,
                textarea,
                [role="button"],
                [draggable="true"],
                [data-no-horizontal-pan="true"]
            `)
        );
    };

    const handleTablePointerDown = (event) => {
        // Solo mouse principale.
        // Su touch lasciamo lavorare lo scroll nativo del browser.
        if (event.pointerType !== "mouse" || event.button !== 0) {
            return;
        }

        if (isHorizontalPanExcludedTarget(event.target)) {
            return;
        }

        const container = horizontalScrollRef.current;

        if (!container) {
            return;
        }

        horizontalPanRef.current = {
            active: true,
            dragging: false,
            startX: event.clientX,
            startY: event.clientY,
            startScrollLeft: container.scrollLeft,
            pointerId: event.pointerId,
        };
    };

    const handleTablePointerMove = (event) => {
        const container = horizontalScrollRef.current;
        const pan = horizontalPanRef.current;

        if (!container || !pan.active || pan.pointerId !== event.pointerId) {
            return;
        }

        const deltaX = event.clientX - pan.startX;
        const deltaY = event.clientY - pan.startY;

        /*
        * Non iniziamo immediatamente il pan:
        * lasciamo un piccolo margine per distinguere click da trascinamento.
        */
        if (!pan.dragging) {
            const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

            if (distance < PAN_THRESHOLD) {
                return;
            }

            /*
            * Se il movimento è chiaramente verticale non intercettiamo
            * l'interazione, così resta possibile scrollare verticalmente.
            */
            if (Math.abs(deltaY) > Math.abs(deltaX)) {
                horizontalPanRef.current.active = false;
                return;
            }

            pan.dragging = true;
            suppressNextTableClickRef.current = true;

            try {
                event.currentTarget.setPointerCapture(event.pointerId);
            } catch {
                // Pointer capture non indispensabile.
            }

            container.classList.add("cursor-grabbing", "select-none");
        }

        event.preventDefault();

        container.scrollLeft =
            pan.startScrollLeft - deltaX;
    };

    const stopTablePan = (event) => {
        const container = horizontalScrollRef.current;
        const pan = horizontalPanRef.current;

        if (!pan.active && !pan.dragging) {
            return;
        }

        if (pan.pointerId !== null && event.pointerId !== pan.pointerId) {
            return;
        }

        if (container) {
            container.classList.remove("cursor-grabbing", "select-none");
        }

        if (pan.dragging) {
            try {
                event.currentTarget.releasePointerCapture(event.pointerId);
            } catch {
                // Ignore.
            }
        }

        horizontalPanRef.current = {
            active: false,
            dragging: false,
            startX: 0,
            startY: 0,
            startScrollLeft: 0,
            pointerId: null,
        };
    };

    const todayFormatted = formatDate(new Date());


    if (isError) return <div>Error loading data</div>;
  
    return (
        <div className='flex flex-col min-h-screen'>
           
            <PopoverComponentCustom title='Assegna Turni' />
            {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
                <div className="w-full">
                    <div className="bg-orange-100 text-orange-600 p-4 mb-6">
                        <p className="text-center text-sm font-semibold">
                            Il profilo non è completo. <br />
                            Compila i campi mancanti{' '}
                            <Link
                            to="/profilo/fatturazione"
                            className="text-indigo-600 hover:text-indigo-800 underline"
                            >
                            cliccando qui
                            </Link>
                        </p>
                    </div>
                </div>
            )}
            <main className="mt-4 pb-4 flex-grow">
                <div className="mx-auto w-full max-w-[1600px] px-4 md:px-6">
                    <div className='z-30 mb-4 w-full'>
                        <SchedulerContextBar
                            units={units}
                            selectedUnit={selectedUnit}
                            onSelectUnit={handleSelectUnit}
                            onResetUnit={handleResetUnitSelection}
                            isUnitsLoading={isLoading}

                            token={token}

                            selectedEmployees={selectedActiveContractEmployees}
                            onEmployeesChange={handleSelectionActiveContractChange}
                            onEmployeeRemove={handleDeselectEmployee}
                            onResetEmployees={handleResetSelection}

                            pageSize={pageSizeActiveContract}
                            onPageSizeChange={handlePageSizeActiveChange}
                            contractStartDate={weekStartISO}
                            contractEndDate={weekEndISO}

                            actions={
                                profile.customer_type !== 'employee' ? (
                                    <>
                                        <span className="hidden h-4 w-px bg-gray-300 sm:block" />
                                        <button
                                            type="button"
                                            onClick={() => setShowInactiveEmployee(true)}
                                            className="inline-flex items-center gap-1 ml-3 text-[11px] font-medium text-gray-500 transition hover:text-indigo-600 hover:underline"
                                        >
                                            <UserMinusIcon className="h-4 w-4" />Visualizza dipendenti non attivi
                                        </button>
                                    </>
                                ) : null
                            }
                            showWorkingAreas={true}
                            selectedWorkingArea={selectedWorkingArea}
                            onWorkingAreaChange={handleWorkingAreaSelection}
                            canLoadWorkingAreas={canLoadWorkingAreas}
                        />

                    
                    </div>

                        <div className='grid grid-cols-1 w-full'>
                            <div
                                style={{ flex: '1 1 auto', width: 'auto' }}
                                className="py-5 px-4 border-t border-l border-r border-gray-200 text-center text-xs font-semibold text-gray-600 uppercase align-middle"
                            >
                                <div className='grid grid-cols-3 sm:grid-cols-1 md:grid-cols-5 sm:justify-start md:justify-around'>
                                    <div className='col-span-1 p-2 flex align-center justify-end sm:justify-center md:justify-end me-3'>
                                        <button
                                            className='text-gray-700 font-semibold px-1 border border-solid shadow-md rounded-md hover:bg-gray-100'
                                            onClick={() => handleNavigateWeek(-1)}
                                        >
                                            <ChevronLeftIcon className='w-5 h-5' />
                                        </button>
                                    </div>
                                    <div className='col-span-1 p-2 flex align-center md:justify-end sm:justify-center me-3'>Seleziona Settimana</div>
                                    <span className='col-span-1 p-2 align-center justify-start sm:justify-center md:justify-start sm:hidden flex'>
                                        <button
                                            className='text-gray-700 font-semibold px-1 border border-solid shadow-md rounded-md hover:bg-gray-100'
                                            onClick={() => handleNavigateWeek(1)}
                                        >
                                            <ChevronRightIcon className='w-5 h-5' />
                                        </button>
                                    </span>
                                    <div
                                        onClick={handleSelectClick}
                                        style={{ cursor: 'pointer' }}
                                        className='col-span-3 sm:col-span-2 border border-gray-300 rounded-md shadow-md p-2 pl-4 flex items-center md:w-4/5 justify-between'
                                    >
                                        <div>
                                            {currentWeek.length > 0 && `${getWeekRange(currentWeek[0], currentWeek[currentWeek.length - 1])} / ${selectedMonth.getFullYear()}`}
                                        </div>
                                        {!calendarVisible ? <ChevronDownIcon className='h-4 w-4' /> : <ChevronUpIcon className='h-4 w-4' />}
                                    </div>
                                    <div className='col-span-1 p-2 align-center justify-start sm:justify-center md:justify-start hidden sm:flex'>
                                        <button
                                            className='text-gray-700 font-semibold px-1 border border-solid shadow-md rounded-md hover:bg-gray-100'
                                            onClick={() => handleNavigateWeek(1)}
                                        >
                                            <ChevronRightIcon className='w-5 h-5' />
                                        </button>
                                    </div>
                                </div>
                                {calendarVisible &&
                                    <CalendarWeekSelect
                                        onWeekSelect={handleWeekSelect}
                                        onCloseCalendar={handleSelectClick}
                                        selectedMonth={selectedMonth}
                                    />
                                }
                            </div>
                        </div>
                        
                        <div className='flex justify-end items-center border-x bordcer-gray-200'>
                            {unconfirmedShiftsIds.length > 0 && (
                                <div className="flex justify-end pb-3">
                                    <button
                                        onClick={handleConfirmShifts}
                                        className="bg-orange-500 text-white py-1 px-2 rounded-md shadow-md hover:bg-orange-300 uppercase text-sm font-semibold me-3"
                                    >
                                        Conferma turni ({unconfirmedShiftsIds.length})
                                    </button>
                                </div>
                            )}
                        </div>
                        
                        <div className="flex max-h-[100vh] min-h-0 flex-col overflow-hidden">
                            {isShiftOperationRunning && (
                                <div className="fixed inset-0 z-[5000] bg-white/10 backdrop-blur-sm flex items-center justify-center">
                                    <div className="flex items-center gap-2 rounded-md bg-white px-4 py-2 shadow-md border border-indigo-100 text-sm text-gray-700">
                                        <svg className="h-5 w-5 animate-spin text-indigo-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                                        </svg>
                                        <span className="text-indigo-700">Aggiornamento turni in corso...</span>
                                    </div>
                                </div>
                            )}

                            {loadingEmployee ? (
                                    <Fetching />
                            ) : (
                                <div className="flex flex-col overflow-y-auto">
                                    {/* TOOLBAR SUPERIORE - STICKY */}
                                    <div className="sticky top-0 z-10 border-x border-b border-gray-200 bg-white shadow-sm">

                                        {/* RIEPILOGO ORE */}
                                        <div className="flex min-h-[52px] items-center justify-between gap-4 border-y border-gray-200 bg-gray-50 px-4 py-1.5">
                                            <div className="min-w-0">
                                                {loadingTotalHours ? (
                                                    <div className="flex items-center gap-2 text-xs font-semibold uppercase text-gray-500">
                                                        <span className="h-2 w-2 animate-pulse rounded-full bg-indigo-500" />
                                                        Calcolo ore in corso...
                                                    </div>
                                                ) : isTotalHoursError ? (
                                                    <div className="flex items-center gap-2 text-xs font-semibold text-orange-600">
                                                        <ExclamationTriangleIcon className="h-4 w-4 shrink-0" />
                                                        <span>Non è possibile effettuare il calcolo delle ore</span>
                                                    </div>
                                                ) : selectedUnit ? (
                                                    <div className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">
                                                        <span className="text-[12px] font-bold uppercase tracking-wide text-gray-500">
                                                            Ore settimanali assegnate e confermate
                                                        </span>

                                                        <span className="text-gray-300">•</span>

                                                        <CustomTooltipComponent
                                                            title={selectedUnit?.name}
                                                            arrow
                                                            placement="top"
                                                        >
                                                            <span className="max-w-[32ch] truncate text-xs font-semibold text-gray-700">
                                                                {selectedUnit?.name}
                                                            </span>
                                                        </CustomTooltipComponent>
                                                    </div>
                                                ) : (
                                                    <div className="text-xs font-medium text-gray-500">
                                                        Seleziona un'unità organizzativa per visualizzare il totale delle ore confermate
                                                    </div>
                                                )}
                                            </div>

                                            {!loadingTotalHours && !isTotalHoursError && selectedUnit && (
                                                <div className="shrink-0 rounded-lg border border-indigo-200 bg-indigo-50 px-3 py-1.5">
                                                    <div className="text-[11px] font-bold uppercase tracking-wide text-indigo-500">
                                                        Totale
                                                        <span className="ml-2 text-sm font-bold text-indigo-700">
                                                            {formatMinutesToHours(totalAssignedHours * 60)}
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>


                                        {/* OPZIONI DI VISUALIZZAZIONE */}
                                        <div className="px-3 py-3">
                                            <div className="mb-2 flex items-center gap-2">
                                                <AdjustmentsHorizontalIcon className="h-4 w-4 text-gray-400" />
                                                <span className="text-[11px] font-bold uppercase tracking-wider text-gray-500">
                                                    Visualizzazione
                                                </span>
                                            </div>

                                            <div className="flex flex-wrap items-center gap-2">
                                                <TogglePillButton
                                                    active={expandAllRows}
                                                    onClick={handleToggleExpandAll}
                                                    icon={BriefcaseIcon}
                                                    label="Tutti i turni"
                                                />

                                                <TogglePillButton
                                                    active={showTurniFissi}
                                                    onClick={handleToggleTurniFissi}
                                                    icon={CalendarDaysIcon}
                                                    label="Turni fissi"
                                                />

                                                <TogglePillButton
                                                    active={showTurniVariabili}
                                                    onClick={handleToggleTurniVariabili}
                                                    icon={ArrowsRightLeftIcon}
                                                    label="Turni a rotazione"
                                                />

                                                <TogglePillButton
                                                    active={showBreaks}
                                                    onClick={handleToggleBreaks}
                                                    icon={LocalBarIcon}
                                                    iconType="mui"
                                                    label="Pause"
                                                />

                                                <TogglePillButton
                                                    active={showWorkingAreas}
                                                    onClick={handleToggleWorkingAreas}
                                                    icon={MapPinIcon}
                                                    label="Aree di lavoro"
                                                />
                                            </div>
                                        </div>

                                        {/* MODALITÀ DRAG & DROP */}
                                        <div className="border-t border-gray-200 bg-indigo-50/50 px-3 py-2.5">
                                            <div className="flex flex-col gap-3 xl:flex-row xl:items-center">

                                                {/* CONTROLLI SINISTRA */}
                                                <div className="flex flex-col gap-2 sm:flex-row sm:items-center">

                                                    <div className="mr-2 flex items-center gap-2">
                                                        <ArrowsRightLeftIcon className="h-4 w-4 text-indigo-600" />

                                                        <span className="text-[11px] font-bold uppercase tracking-wider text-indigo-700">
                                                            Trascinamento
                                                        </span>
                                                    </div>

                                                    {/* SPOSTA */}
                                                    <button
                                                        type="button"
                                                        aria-label="Attiva modalità sposta turno"
                                                        aria-pressed={dragMode === "move"}
                                                        onClick={() => setDragMode(prev => prev === "move" ? null : "move")}
                                                        className={`
                                                            flex items-center gap-2 rounded-lg border px-3 py-2
                                                            text-left transition-all duration-150
                                                            ${
                                                                dragMode === "move"
                                                                    ? "border-indigo-400 bg-indigo-100 text-indigo-800 shadow-sm"
                                                                    : "border-gray-200 bg-gray-50 text-gray-700 hover:border-indigo-200 hover:bg-indigo-50"
                                                            }
                                                        `}
                                                    >
                                                        <CustomTooltipComponent
                                                            title="Trascina il turno sulla nuova casella per spostarlo. Il turno verrà rimosso dalla posizione originale."
                                                            placement="top"
                                                            arrow
                                                        >
                                                            <span onClick={(event) => event.stopPropagation()} className="inline-flex">
                                                                <QuestionMarkCircleIcon className={`h-5 w-5 shrink-0 ${dragMode === "move" ? "text-indigo-700" : "text-gray-400"}`} />
                                                            </span>
                                                        </CustomTooltipComponent>

                                                        <span className="text-xs font-semibold">
                                                            Sposta turno
                                                        </span>

                                                        <span
                                                            className={`
                                                                relative ml-auto inline-flex h-5 w-9 shrink-0 items-center rounded-full
                                                                transition-colors ${dragMode === "move" ? "bg-indigo-600" : "bg-gray-300"}
                                                            `}
                                                            aria-hidden="true"
                                                        >
                                                            <span
                                                                className={`
                                                                    inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform
                                                                    ${dragMode === "move" ? "translate-x-4" : "translate-x-1"}
                                                                `}
                                                            />
                                                        </span>
                                                    </button>

                                                    {/* DUPLICA */}
                                                    <button
                                                        type="button"
                                                        aria-label="Attiva modalità duplica turno"
                                                        aria-pressed={dragMode === "copy"}
                                                        onClick={() => setDragMode(prev => prev === "copy" ? null : "copy")}
                                                        className={`
                                                            flex items-center gap-2 rounded-lg border px-3 py-2
                                                            text-left transition-all duration-150
                                                            ${dragMode === "copy" ? "border-violet-400 bg-violet-100 text-violet-800 shadow-sm" : "border-gray-200 bg-gray-50 text-gray-700 hover:border-violet-200 hover:bg-violet-50"}
                                                        `}
                                                    >
                                                        <CustomTooltipComponent
                                                            title="Trascina il turno sulla casella desiderata per crearne una copia. Il turno originale rimarrà invariato."
                                                            placement="top"
                                                            arrow
                                                        >
                                                            <span onClick={(event) => event.stopPropagation()} className="inline-flex">
                                                                <QuestionMarkCircleIcon className={`h-5 w-5 shrink-0 ${dragMode === "copy" ? "text-violet-700" : "text-gray-400"}`} />
                                                            </span>
                                                        </CustomTooltipComponent>

                                                        <span className="text-xs font-semibold">
                                                            Duplica turno
                                                        </span>

                                                        <span
                                                            className={`
                                                                relative ml-auto inline-flex h-5 w-9 shrink-0 items-center rounded-full
                                                                transition-colors ${dragMode === "copy" ? "bg-violet-600" : "bg-gray-300"}
                                                            `}
                                                            aria-hidden="true"
                                                        >
                                                            <span
                                                                className={`
                                                                    inline-block h-4 w-4 transform rounded-full bg-white shadow-sm
                                                                    transition-transform ${dragMode === "copy" ? "translate-x-4" : "translate-x-1"}
                                                                `}
                                                            />
                                                        </span>
                                                    </button>
                                                </div>


                                                {/* AZIONE DESTRA */}
                                                {profile?.customer_type !== 'employee' || canManageWorkingAreas ? (
                                                    <div className="flex xl:ml-auto xl:justify-end">
                                                        <button
                                                            type="button"
                                                            onClick={() => setShowBulkWorkingAreaModal(true)}
                                                            className="
                                                                inline-flex items-center justify-center gap-2
                                                                rounded-lg border border-indigo-200 bg-white
                                                                px-3 py-2 text-xs font-semibold text-indigo-700
                                                                shadow-sm transition-all duration-150
                                                                hover:border-indigo-300 hover:bg-indigo-50 hover:text-indigo-800
                                                            "
                                                        >
                                                            <MapPinIcon className="h-4 w-4" /> Associa area
                                                        </button>
                                                    </div>
                                                ) : ('')}
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        ref={horizontalScrollRef}
                                        className="min-h-0 flex-1 overflow-x-auto overflow-y-auto cursor-grab touch-pan-x touch-pan-y"
                                        onPointerDown={handleTablePointerDown}
                                        onPointerMove={handleTablePointerMove}
                                        onPointerUp={stopTablePan}
                                        onPointerCancel={stopTablePan}
                                        onPointerLeave={(event) => {
                                            /*
                                            * Con pointerCapture il drag può continuare anche fuori.
                                            * Se non stiamo trascinando, puliamo semplicemente lo stato.
                                            */
                                            if (!horizontalPanRef.current.dragging) {
                                                stopTablePan(event);
                                            }
                                        }}
                                    >
                                        <table className="w-max min-w-full border-collapse">
                                            <thead className="sticky top-0 z-30 bg-gray-50 shadow-sm">
                                                <tr>
                                                    {/* DIPENDENTE - unica colonna sticky, con ombra per indicare che "galleggia" sopra le colonne che scorrono */}
                                                    <th className="sticky left-0 z-40 w-[205px] min-w-[205px] max-w-[205px] border border-gray-300 bg-gray-100 px-3 py-3 text-left shadow-[4px_0_6px_-2px_rgba(0,0,0,0.08)] ring-1 ring-inset ring-gray-200">
                                                        <div className="flex items-center justify-between gap-2">
                                                            <span className="text-xs font-bold uppercase tracking-wide text-gray-700">Dipendenti</span>

                                                            {selectedEmployees.length > 0 && (
                                                                <CustomTooltipComponent title={areAllExpanded ? "Comprimi tutte le righe" : "Espandi tutte le righe"} placement="top" arrow>
                                                                    <button
                                                                        type="button"
                                                                        onClick={handleToggleExpandAll}
                                                                        aria-label={areAllExpanded ? "Comprimi tutte le righe" : "Espandi tutte le righe"}
                                                                        className={`inline-flex h-8 items-center gap-1.5 rounded-md border px-2.5 text-[11px] font-semibold uppercase shadow-sm transition-colors
                                                                            ${areAllExpanded
                                                                                    ? "border-indigo-400 bg-indigo-100 text-indigo-700 hover:bg-indigo-200"
                                                                                    : "border-gray-300 bg-white text-gray-600 hover:border-indigo-400 hover:bg-indigo-50 hover:text-indigo-700"
                                                                            }
                                                                        `}
                                                                    >
                                                                        {areAllExpanded ? (
                                                                            <>
                                                                                <ChevronUpIcon className="h-4 w-4" />
                                                                                <span>Comprimi</span>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <ChevronDownIcon className="h-4 w-4" />
                                                                                <span>Espandi</span>
                                                                            </>
                                                                        )}
                                                                    </button>
                                                                </CustomTooltipComponent>
                                                            )}
                                                        </div>
                                                    </th>

                                                    {/* GIORNI */}
                                                    {currentWeek.map((day, index) => {
                                                        const formattedDay = formatDate(day);
                                                        const isHoliday = holidays.some(holiday => holiday.date === formattedDay);
                                                        const weekend = isWeekend(day);
                                                        const isToday = formattedDay === todayFormatted;

                                                        return (
                                                            <th
                                                                key={index}
                                                                className={`relative w-[130px] min-w-[130px] max-w-[130px] border border-gray-300 px-2 py-3 text-center text-xs uppercase
                                                                    ${isToday ? "bg-indigo-50 ring-2 ring-inset ring-indigo-400 z-10" : "bg-gray-50"}
                                                                    ${isHoliday ? "font-bold text-amber-600" : weekend ? "font-bold text-indigo-600" : "font-bold text-gray-600"}
                                                                `}
                                                            >
                                                                {formatDay(day)}
                                                                {isToday && (
                                                                    <span className="ml-1 inline-block h-1.5 w-1.5 rounded-full bg-indigo-500 align-middle" aria-hidden="true" />
                                                                )}
                                                            </th>
                                                        );
                                                    })}
                                                </tr>
                                            </thead>

                                            <tbody className="bg-white">
                                                {loadingEmployee && (
                                                    <tr>
                                                        <td colSpan={currentWeek.length + 1} className="border border-gray-300 px-4 py-6 text-center">
                                                            <Fetching />
                                                        </td>
                                                    </tr>
                                                )}

                                                {!loadingEmployee && selectedEmployees.length === 0 && (
                                                    <tr>
                                                        <td colSpan={currentWeek.length + 1} className="border border-gray-300 px-4 py-8 text-center text-sm font-semibold uppercase text-gray-600">
                                                            Non sono presenti anagrafiche
                                                        </td>
                                                    </tr>
                                                )}

                                                {selectedEmployees
                                                    .filter(employee => selectedActiveContractEmployees.length === 0 || selectedActiveContractEmployees.some(selected => selected.id === employee.id))
                                                    .map((dipendente, rowIndex) => {
                                                        const isRowExpanded = !!expandedRows[dipendente.id];
                                                        // Lookup O(1) invece di .filter() su tutto l'array ad ogni render
                                                        const employeeDays = workingHoursByEmployeeId.get(dipendente.id) || [];
                                                        const assignedMinutes = calculateWeeklyTotalMinutes(employeeDays);
                                                        const plannedMinutes = (dipendente?.week_hours || 0) * 60;
                                                        const difference = assignedMinutes - plannedMinutes;
                                                        const isAChiamata = dipendente?.shift_type === "a_chiamata";
                                                        const isSenzaCalendario = dipendente?.shift_type === "senza_calendario";
                                                        const hasWorkingSchedule = isAChiamata || Number(dipendente?.week_hours) > 0;

                                                        const getEmployeeCellAccent = () => {
                                                            if (isSenzaCalendario || isAChiamata || !hasWorkingSchedule) {
                                                                return {
                                                                    gradient: "after:bg-gradient-to-l after:from-gray-200/30 after:via-gray-100/15 after:to-transparent",
                                                                    border: "before:bg-gray-300",
                                                                };
                                                            }

                                                            if (difference === 0) {
                                                                return {
                                                                    gradient: "after:bg-gradient-to-l after:from-teal-300/30 after:via-teal-100/15 after:to-transparent",
                                                                    border: "before:bg-teal-300",
                                                                };
                                                            }

                                                            return {
                                                                gradient: "after:bg-gradient-to-l after:from-red-300/30 after:via-red-100/15 after:to-transparent",
                                                                border: "before:bg-red-300",
                                                            };
                                                        };

                                                        const employeeCellAccent = getEmployeeCellAccent();

                                                        const justificationDurationTotal =
                                                            employeeDays.reduce((sum, wh) => {
                                                                const approvedIncrease = (wh.justification_requests || [])
                                                                    .filter(jr => jr.status === "approved" && jr.strategy === "increase")
                                                                    .reduce((subSum, jr) => subSum + (jr.duration || 0), 0);
                                                                return sum + approvedIncrease;
                                                            }, 0);

                                                        const employeeName = dipendente.first_name ? `${dipendente.last_name} ${dipendente.first_name}` : dipendente.cf;


                                                        return (
                                                            <React.Fragment key={dipendente.id}>
                                                                <tr className="group">
                                                                    <td
                                                                        className={`
                                                                            sticky left-0 z-20
                                                                            w-[205px] min-w-[205px] max-w-[205px]
                                                                            border-y border-l border-gray-300
                                                                            bg-white
                                                                            px-3 py-3 align-top
                                                                            hover:bg-gray-50

                                                                            before:pointer-events-none
                                                                            before:absolute
                                                                            before:right-0
                                                                            before:top-0
                                                                            before:bottom-0
                                                                            before:z-10
                                                                            before:w-px
                                                                            ${employeeCellAccent.border}

                                                                            after:pointer-events-none
                                                                            after:absolute
                                                                            after:right-px
                                                                            after:top-0
                                                                            after:bottom-0
                                                                            after:w-3
                                                                            ${employeeCellAccent.gradient}

                                                                            before:content-['']
                                                                            after:content-['']
                                                                        `}
                                                                    >
                                                                        <div className="flex flex-col ">
                                                                            {/* Nome + pulsante espansione */}
                                                                            <div className="flex items-start gap-2">
                                                                                <CustomTooltipComponent title={isRowExpanded ? "Comprimi dettagli" : "Espandi dettagli"} placement="top" arrow>
                                                                                    <button type="button" onClick={() => toggleRow(dipendente.id)}
                                                                                        aria-label={isRowExpanded ? "Comprimi dettagli" : "Espandi dettagli"}
                                                                                        className={`mt-0.5 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md border shadow-sm transition-colors
                                                                                            ${isRowExpanded ? "border-indigo-400 bg-indigo-100 text-indigo-700 hover:bg-indigo-200" : "border-gray-300 bg-white text-gray-500 hover:border-indigo-400 hover:bg-indigo-50 hover:text-indigo-700"}
                                                                                        `}
                                                                                    >
                                                                                        {isRowExpanded ? (
                                                                                            <ChevronUpIcon className="h-4 w-4" />
                                                                                        ) : (
                                                                                            <ChevronDownIcon className="h-4 w-4" />
                                                                                        )}
                                                                                    </button>
                                                                                </CustomTooltipComponent>

                                                                                <div className="min-w-0 flex-1 pt-1">
                                                                                    <Link to={`/dipendenti/${dipendente.cf}`} title={employeeName} className="block truncate text-xs font-bold uppercase text-gray-800 hover:text-indigo-600">
                                                                                        {employeeName}
                                                                                    </Link>
                                                                                        {isAChiamata && (
                                                                                            <CustomTooltipComponent title='Contratto A Chiamata' >
                                                                                                <span className="mt-1 inline-flex items-center rounded-full border border-amber-200 bg-amber-50 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-700">
                                                                                                    a chiamata
                                                                                                </span>
                                                                                            </CustomTooltipComponent>
                                                                                        )}
                                                                                </div>
                                                                            </div>

                                                                            {!isSenzaCalendario && (
                                                                                <div className="mt-3 border-t-2 border-gray-200 pt-2">
                                                                                    {isAChiamata ? (
                                                                                        <div className="flex items-center justify-between gap-2">
                                                                                            <span className="text-xs font-semibold uppercase text-gray-500">Assegnate</span>
                                                                                            <span className="text-xs font-bold text-gray-800">{formatMinutesToHours(assignedMinutes)}</span>
                                                                                        </div>
                                                                                    ) : hasWorkingSchedule ? (
                                                                                        <>
                                                                                            <div className="flex items-center justify-between gap-2">
                                                                                                <span className="text-xs font-semibold uppercase text-gray-500">Ore </span>
                                                                                                <div className="flex items-baseline gap-1">
                                                                                                    <span className={`text-xs font-bold ${difference === 0 ? "text-emerald-600" : "text-gray-800"}`}>
                                                                                                        {formatMinutesToHours(assignedMinutes)}
                                                                                                    </span>
                                                                                                    <span className="text-xs font-semibold text-gray-400">/</span>
                                                                                                    <span className={`text-xs font-semibold ${difference === 0 ? "text-emerald-600" : "text-gray-500"}`}>
                                                                                                        {formatMinutesToHours(plannedMinutes)}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>

                                                                                            {/* Differenza + giustificativi */}
                                                                                            {(difference !== 0 ||
                                                                                                (canManageJustifications && justificationDurationTotal > 0)) && (
                                                                                                <div className="mt-1.5 flex flex-wrap items-center gap-1">
                                                                                                    {difference !== 0 && (
                                                                                                        <CustomTooltipComponent title="Differenza tra ore previste e ore assegnate" placement="top" arrow>
                                                                                                            <span className={`inline-flex rounded-md border px-1.5 py-0.5 text-[11px] font-bold
                                                                                                                ${difference > 0 ? "border-orange-200 bg-orange-50 text-orange-700" : "border-red-200 bg-red-50 text-red-600"}`}
                                                                                                            >
                                                                                                                {difference > 0 ? "+" : "-"}
                                                                                                                {formatMinutesToHours(Math.abs(difference))}
                                                                                                            </span>
                                                                                                        </CustomTooltipComponent>
                                                                                                    )}

                                                                                                    {canManageJustifications && justificationDurationTotal > 0 && (
                                                                                                        <CustomTooltipComponent title="Ore derivanti da giustificativi approvati in aumento" placement="top" arrow>
                                                                                                            <span className="inline-flex rounded-md border border-violet-200 bg-violet-50 px-1.5 py-0.5 text-[11px] font-bold text-violet-700">
                                                                                                                + {formatMinutesToHours(justificationDurationTotal)}{" "}giust.
                                                                                                            </span>
                                                                                                        </CustomTooltipComponent>
                                                                                                    )}
                                                                                                </div>
                                                                                            )}

                                                                                            {/* Dettaglio solo in espansione */}
                                                                                            {isRowExpanded && (
                                                                                                <div className="mt-2 grid grid-cols-2 gap-1.5">
                                                                                                    <div className="rounded-md border border-gray-200 bg-gray-100 px-2 py-1.5">
                                                                                                        <div className="text-[11px] font-semibold uppercase text-gray-500">Previste</div>

                                                                                                        <div className={`mt-0.5 text-[11px] font-bold ${difference === 0 ? "text-emerald-600" : "text-gray-700"}`}>
                                                                                                            {formatMinutesToHours(plannedMinutes)}
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <div className="rounded-md border border-indigo-200 bg-indigo-50 px-2 py-1.5">
                                                                                                        <div className="text-[11px] font-semibold uppercase text-indigo-500">
                                                                                                            Assegnate
                                                                                                        </div>

                                                                                                        <div className={`mt-0.5 text-[11px] font-bold ${difference === 0 ? "text-emerald-600" : "text-indigo-700"}`}>
                                                                                                            {formatMinutesToHours(assignedMinutes)}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}
                                                                                        </>
                                                                                    ) : (
                                                                                        <div className="rounded-md border border-red-200 bg-red-50 px-2 py-2">
                                                                                            <div className="text-[11px] font-semibold leading-tight text-red-600">
                                                                                                Orario lavorativo non configurato
                                                                                            </div>

                                                                                            <Link to={`/dipendenti/${dipendente.cf}/edit?tab=2`} className="mt-1 inline-block text-[11px] font-bold text-indigo-600 underline">
                                                                                                SALVALO QUI
                                                                                            </Link>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </td>

                                                                    {currentWeek.map((day, index) => {
                                                                        const formattedDay = formatDate(day);
                                                                        const workingHour = employeeWorkingHours.find(wh => wh.date === formattedDay && wh.employeeId === dipendente.id);
                                                                        const isHoliday = holidays.some(holiday => holiday.date === formattedDay);
                                                                        const weekend = isWeekend(day);
                                                                        const isToday = formattedDay === todayFormatted;
                                                                        const hasActiveContract = workingHour?.has_active_contract === true;
                                                                        const hasJustifications = workingHour?.has_justifications === true;
                                                                        const weekHours = workingHour?.week_hours;
                                                                        const shiftType = workingHour?.shift_type;
                                                                        const totalDuration = calculateTotalHours(workingHour?.shifts || []);
                                                                        const isFisso = workingHour?.shift_type === "fisso";
                                                                        const canHaveShift = hasActiveContract && (Number(weekHours) > 0 || shiftType === "a_chiamata");
                                                                        const dayBlocked = isDayBlocked(formattedDay);
                                                                        const canShowActionBar = canManageShifts || canManageJustifications || canManageWorkingAreas;
                                                                        const showShiftIcon = canHaveShift && canManageShifts && !isSenzaCalendario;
                                                                        const showWorkingAreaIcon = canHaveShift && canManageWorkingAreas && !isSenzaCalendario;
                                                                        const showJustificationIcon = (canHaveShift || isSenzaCalendario) && canManageJustifications;
                                                                        const showActionBar = (canHaveShift || isSenzaCalendario) && canShowActionBar;
                                                                        // "giorno bloccato" e' uno stato puramente informativo: la cella viene disabilitata
                                                                        // con un tooltip invece di interrompere il flusso con un alert modale ad ogni click.
                                                                        const cellDisabledByBlock = canHaveShift && dayBlocked && !workingHour;

                                                                        const cellContent = (
                                                                            <td
                                                                                key={index}
                                                                                className={`relative w-[150px] min-w-[150px] max-w-[150px] border px-1 py-1 align-top text-center text-xs font-semibold text-gray-900
                                                                                    ${isToday ? "border-indigo-200" : "border-gray-300"}
                                                                                    ${cellDisabledByBlock ? "cursor-not-allowed opacity-60" : !hasActiveContract ? "cursor-pointer" : workingHour && workingHour.typology === "senza_calendario" ? "cursor-pointer bg-gray-200" : "bg-white"}
                                                                                `}
                                                                                style={
                                                                                    !hasActiveContract ? PatternInactiveEmployee() : workingHour && workingHour.typology === "senza_calendario"
                                                                                        ? {backgroundColor: "#e5e7eb", }
                                                                                        : {...(isHoliday && SvgHoliday()), ...(weekend && SvgPattern()),}
                                                                                }
                                                                                onClick={() => {
                                                                                    if (suppressNextTableClickRef.current) {
                                                                                        suppressNextTableClickRef.current = false;
                                                                                        return;
                                                                                    }
                                                                                    
                                                                                    if (dayBlocked) {
                                                                                        // Nessun alert bloccante: la cella e' gia' visivamente disabilitata (vedi cellDisabledByBlock)
                                                                                        return;
                                                                                    }

                                                                                    if (!hasActiveContract) {
                                                                                        Swal.fire({
                                                                                            title: "Nessun contratto attivo",
                                                                                            html: `Per modificare i dati del contratto o crearne uno nuovo, clicca <a href="/dipendenti/${dipendente.cf}/edit?tab=2" style="color: #6366F1;">QUI</a>`,
                                                                                            icon: "warning",
                                                                                        });

                                                                                        return;
                                                                                    }

                                                                                    if (workingHour && workingHour.typology === "senza_calendario") {
                                                                                        Swal.fire({
                                                                                            title: "Contratto Senza Calendario",
                                                                                            text: 'La tipologia di contratto del dipendente è "senza calendario" e non è possibile assegnare un turno.',
                                                                                            icon: "warning",
                                                                                        });

                                                                                        return;
                                                                                    }

                                                                                    if (!canHaveShift) {
                                                                                        return;
                                                                                    }

                                                                                    if (!workingHour) {
                                                                                        handleSelectedDay(dipendente.id, formattedDay, dipendente.cf, dipendente.last_name || "", dipendente.first_name || "");
                                                                                    }
                                                                                }}
                                                                                onDragOver={canHaveShift && !dayBlocked ? handleCellDragOver : undefined}
                                                                                onDrop={canHaveShift && !dayBlocked ? e => handleCellDrop(e, dipendente.id, formattedDay) : undefined}
                                                                            >
                                                                                {workingHour ? (
                                                                                    <div className="mb-4 min-h-[90px] w-full pb-8">
                                                                                        <ShiftCard
                                                                                            workingHour={workingHour}
                                                                                            dipendente={dipendente}
                                                                                            handleDeleteDailyWh={handleDeleteDailyWh}
                                                                                            formattedDay={formattedDay}
                                                                                            selectedUnit={selectedUnit?.id}
                                                                                            handlePlusCircleClick={handlePlusCircleClick}
                                                                                            handleEditOuPairing={handleEditOuPairing}
                                                                                            handleConfirmSingleShift={handleConfirmSingleShift}
                                                                                            dayBlocked={dayBlocked}
                                                                                            showBreaks={showBreaks}
                                                                                            showWorkingAreas={showWorkingAreas}
                                                                                            onShiftDragStart={handleShiftDragStart}
                                                                                            showDetails={isRowExpanded}
                                                                                            dragMode={dragMode}
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="flex min-h-[90px] items-center justify-center px-1">
                                                                                        {canHaveShift ? (
                                                                                            cellDisabledByBlock ? (
                                                                                                <div className="flex flex-col items-center justify-center gap-1 text-gray-400">
                                                                                                    <NoSymbolIcon className="h-5 w-5" aria-hidden="true" />
                                                                                                    <span className="text-[11px] font-semibold leading-tight">Giorno bloccato</span>
                                                                                                </div>
                                                                                            ) : (
                                                                                                <button
                                                                                                    type="button"
                                                                                                    aria-label="Assegna turno"
                                                                                                    onClick={event => {
                                                                                                        event.stopPropagation();

                                                                                                        handlePlusCircleClick(
                                                                                                            dipendente.id,
                                                                                                            formattedDay,
                                                                                                            dipendente.cf,
                                                                                                            dipendente.last_name || "",
                                                                                                            dipendente.first_name || "",
                                                                                                            selectedUnit || ""
                                                                                                        );
                                                                                                    }}
                                                                                                    className="inline-flex flex-col items-center justify-center gap-1 rounded-md px-2 py-2 text-gray-500 transition-colors hover:bg-indigo-50 hover:text-indigo-600"
                                                                                                >
                                                                                                    <PlusCircleIcon className="h-6 w-6" />
                                                                                                    <span className="text-[11px] font-bold uppercase">Assegna</span>
                                                                                                </button>
                                                                                            )
                                                                                        ) : (
                                                                                            <div className="flex flex-col items-center justify-center gap-1 text-gray-400">
                                                                                                <NoSymbolIcon className="h-5 w-5 text-red-400" />
                                                                                                <span className="text-[11px] font-semibold leading-tight">
                                                                                                    Orario non configurato
                                                                                                </span>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                )}

                                                                                {((hasActiveContract && canHaveShift) || isSenzaCalendario) && (
                                                                                    <div className="absolute inset-x-0 bottom-0">
                                                                                        {totalDuration && (
                                                                                            <div className="py-0.5 text-[12px] font-bold text-gray-700">
                                                                                                {totalDuration}
                                                                                            </div>
                                                                                        )}

                                                                                        {showActionBar && (
                                                                                            <div className={`flex items-center justify-around border-t ${isSenzaCalendario ? 'border-gray-300' : 'border-gray-200'} px-1 py-1`}>
                                                                                                {showShiftIcon && (
                                                                                                    <CustomTooltipComponent
                                                                                                        title={isFisso ? "Informazioni turno fisso" : "Aggiungi turno"}
                                                                                                        placement="top"
                                                                                                        arrow
                                                                                                    >
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            aria-label={isFisso ? "Informazioni turno fisso" : "Aggiungi turno"}
                                                                                                            onClick={event => {
                                                                                                                event.stopPropagation();

                                                                                                                if (!isFisso && dayBlocked) {
                                                                                                                    return;
                                                                                                                }

                                                                                                                handlePlusCircleClick(
                                                                                                                    dipendente.id,
                                                                                                                    formattedDay,
                                                                                                                    dipendente.cf,
                                                                                                                    dipendente.last_name || "",
                                                                                                                    dipendente.first_name || "",
                                                                                                                    selectedUnit || ""
                                                                                                                );
                                                                                                            }}
                                                                                                            className="inline-flex items-center justify-center rounded p-0.5 text-gray-600 hover:bg-indigo-50 hover:text-indigo-700"
                                                                                                        >
                                                                                                            {isFisso ? (
                                                                                                                <InformationCircleIcon className="h-5 w-5" />
                                                                                                            ) : (
                                                                                                                <PlusCircleIcon className="h-5 w-5" />
                                                                                                            )}
                                                                                                        </button>
                                                                                                    </CustomTooltipComponent>
                                                                                                )}

                                                                                                {/* AREA - colore teal per distinguerla visivamente dal turno */}
                                                                                                {showWorkingAreaIcon && (
                                                                                                    <CustomTooltipComponent title="Associa area di lavoro" placement="top" arrow>
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            aria-label="Associa area di lavoro"
                                                                                                            disabled={dayBlocked}
                                                                                                            onClick={event => {
                                                                                                                event.stopPropagation();
                                                                                                                if (dayBlocked) {return;}
                                                                                                                openWorkingAreaModal(dipendente, formattedDay);
                                                                                                            }}
                                                                                                            className={`inline-flex items-center justify-center rounded p-0.5 ${dayBlocked ? "cursor-not-allowed text-gray-300" : "text-gray-600 hover:bg-teal-50 hover:text-teal-700"}`}
                                                                                                        >
                                                                                                            <MapPinIcon className="h-5 w-5" />
                                                                                                        </button>
                                                                                                    </CustomTooltipComponent>
                                                                                                )}

                                                                                                {/* GIUSTIFICATIVI - colore violet, coerente col pallino di notifica */}
                                                                                                {showJustificationIcon && (
                                                                                                    <CustomTooltipComponent title="Giustificativi" placement="top" arrow>
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            aria-label="Giustificativi"
                                                                                                            onClick={event => {event.stopPropagation(); openModalAddGiustificativo(dipendente, formattedDay, formattedDay);}}
                                                                                                            className="relative inline-flex items-center justify-center rounded p-0.5 text-gray-600 hover:bg-violet-50 hover:text-violet-700"
                                                                                                        >
                                                                                                            <ClipboardDocumentCheckIcon className="h-5 w-5" />
                                                                                                            {hasJustifications && (<span className="absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full bg-violet-600 ring-2 ring-white" />)}
                                                                                                        </button>
                                                                                                    </CustomTooltipComponent>
                                                                                                )}
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            </td>
                                                                        );

                                                                        return cellDisabledByBlock ? (
                                                                            <CustomTooltipComponent key={index} title="Giorno bloccato: modifiche non consentite" placement="top" arrow>
                                                                                {cellContent}
                                                                            </CustomTooltipComponent>
                                                                        ) : cellContent;
                                                                    })}
                                                                </tr>

                                                                {/* Separazione più visibile tra dipendenti */}
                                                                {rowIndex < selectedEmployees.length - 1 && (
                                                                    <tr>
                                                                        <td colSpan={currentWeek.length + 1} className="h-2 border-x-0 border-y-2 border-gray-300 bg-gray-100" />
                                                                    </tr>
                                                                )}
                                                            </React.Fragment>
                                                        );
                                                    })}
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            )}
                            {!hidePaginationActive && (
                                <div className="flex justify-between mt-8 px-8">
                                    <button 
                                        className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                        onClick={handlePreviousPageActive}
                                        disabled={pageActiveContract === 1}
                                    >
                                        Precedente
                                    </button>
                                    <span className='text-sm font-medium text-gray-900'>Pagina {pageActiveContract} di {Math.ceil(totalResultActiveContract / pageSizeActiveContract)}</span>
                                    <button 
                                        className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                        onClick={handleNextPageActive} 
                                        disabled={pageActiveContract * pageSizeActiveContract >= totalResultActiveContract}
                                    >
                                        Successivo
                                    </button>
                                </div>
                            )}
                        </div>
                        <WorkingAreaAssignmentModal
                            open={workingAreaModalOpen}
                            onClose={closeWorkingAreaModal}
                            employee={selectedWorkingAreaEmployee}
                            selectedDay={selectedWorkingAreaDay}
                            permission="attendance"
                            onSave={handleWorkingAreaChange}

                            onSwitchToJustification={handleSwitchWorkingAreaToJustification}
                            canManageJustifications={canManageJustifications}
                            canManageWorkingAreas={canManageWorkingAreas}
                            canViewWorkingAreas={canViewWorkingAreas}
                        />
                        <WorkingAreaBulkAssignmentModal
                            open={showBulkWorkingAreaModal}
                            onClose={() => setShowBulkWorkingAreaModal(false)}
                            permission="shifts"
                            onSave={handleBulkWorkingAreaChange}
                            units={units}
                            initialStartDate={currentWeek.length > 0 ? formatDateWeekSelected(currentWeek[0]) : null}
                            initialEndDate={currentWeek.length > 0 ? formatDateWeekSelected(currentWeek[currentWeek.length - 1]) : null}
                        />
                    </div>
                    
                    {modalOpen && (
                        <Transition.Root show={modalOpen} as={Fragment}>
                            <Dialog className="relative z-[999]" onClose={() => {}} >
                                <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
                                    <div className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm transition-opacity" />
                                </Transition.Child>

                                <div className="fixed inset-0 z-[1000] w-screen overflow-y-auto">
                                    <div className="flex min-h-full items-start justify-center px-4 pb-8 pt-10 sm:px-6">
                                        <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                                            leave="ease-in duration-200"
                                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                        >
                                            <Dialog.Panel className="flex max-h-full w-full max-w-6xl flex-col overflow-visible rounded-xl border border-gray-200 bg-gray-50 text-left shadow-2xl transition-all">
                                                <div className="flex items-center justify-between rounded-t-xl border-b border-indigo-100 bg-indigo-50/70 px-5 py-4 sm:px-6">
                                                    <div className="flex items-center gap-3">
                                                        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white text-indigo-600 shadow-sm ring-1 ring-indigo-100">
                                                            <AdjustmentsHorizontalIcon className="h-5 w-5" />
                                                        </div>

                                                        <div>
                                                            <Dialog.Title className="text-sm font-semibold uppercase text-indigo-800">
                                                                Gestione turni
                                                            </Dialog.Title>

                                                            <p className="mt-0.5 text-xs text-gray-500">
                                                                Seleziona la modalità di assegnazione del turno
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <button
                                                        type="button"
                                                        onClick={handleCloseModal}
                                                        className="rounded-md border border-gray-300 bg-white px-4 py-2 text-xs font-semibold uppercase text-gray-700 shadow-sm transition-colors hover:bg-gray-50"
                                                    >
                                                        Chiudi
                                                    </button>
                                                </div>

                                                <div className="px-5 py-5 sm:px-6">
                                                    {selectedDay && (
                                                        <div>
                                                            <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-indigo-700">
                                                                Modalità di assegnazione
                                                            </p>

                                                            <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
                                                                {shiftAssignmentOptions.map((option) => {
                                                                    const isSelected = selectedOption === option.value;

                                                                    return (
                                                                        <button
                                                                            key={option.value}
                                                                            type="button"
                                                                            onClick={() => handleToggleChange(option.value)}
                                                                            className={`rounded-lg border px-4 py-4 text-left shadow-sm transition-all ${isSelected ? "border-indigo-300 bg-indigo-100 text-white" : "border-gray-200 bg-white text-gray-700 hover:border-indigo-300 hover:bg-indigo-50/50" }`}
                                                                        >
                                                                            <span className={`block text-sm font-semibold ${isSelected ? "text-indigo-700" : "text-gray-800"}`}>{option.label}</span>

                                                                            <span className={`mt-1.5 block text-xs leading-5 ${isSelected ? "text-indigo-700" : "text-gray-500"}`}>{option.description}</span>
                                                                        </button>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {selectedOption && (
                                                        <div className="mt-5 border-t border-gray-200 pt-5">
                                                            {selectedDay && selectedOption === "CREA FASCIA ORARIA" && (
                                                                <div>
                                                                    <div className="mb-4">
                                                                        <h3 className="text-sm font-semibold uppercase text-indigo-800">Crea fascia oraria</h3>
                                                                        <p className="mt-1 text-xs text-gray-500">Configura l’unità organizzativa e gli intervalli della giornata</p>
                                                                    </div>

                                                                    <PairOrgUnit
                                                                        onSelectOrganizationalUnit={handleTemporarySelectUnit}
                                                                        selectedOU={selectedUnit}
                                                                        onResetOrganizationalUnit={handleResetOUtoPairSelection}
                                                                    />

                                                                    <AddDailyWorkingHour
                                                                        selectedDay={selectedDay}
                                                                        onSaveDailyWorkingHour={handleSaveWorkingHour}
                                                                        allowHiddenBreaks={settingHiddenBreak}
                                                                        onAssignWh="assignWhComponent"
                                                                    />
                                                                </div>
                                                            )}

                                                            {selectedDay && selectedOption === "ASSEGNA TURNO GIORNALIERO" && (
                                                                <div>
                                                                    <div className="mb-4">
                                                                        <h3 className="text-sm font-semibold uppercase text-indigo-800">
                                                                            Assegna turno giornaliero
                                                                        </h3>

                                                                        <p className="mt-1 text-xs text-gray-500">
                                                                            Seleziona il turno giornaliero da applicare alla data scelta
                                                                        </p>
                                                                    </div>

                                                                    {workingHours.length > 0 ? (
                                                                        <div className='bg-white p-3 rounded-xl border border-gray-200 shadow-md mb-3'>
                                                                            <div className="grid grid-cols-1 gap-2 sm:grid-cols-[200px_minmax(0,1fr)] sm:items-center ">
                                                                                <label className="text-xs font-semibold text-gray-600">
                                                                                    Seleziona turno giornaliero
                                                                                </label>

                                                                                <div className="min-w-0 rounded-md border border-gray-200 bg-white">
                                                                                    <ComboboxAutocomplete
                                                                                        options={workingHours}
                                                                                        bgActiveColor="bg-indigo-100"
                                                                                        textActiveColor="text-gray-900"
                                                                                        placeholder="Seleziona turno giornaliero..."
                                                                                        onChange={(value) => setSelectedWorkingHourId(value?.id ?? null)}
                                                                                        value={workingHours.find((workingHour) => workingHour.id === selectedWorkingHourId) || null}
                                                                                        positionOptions="relative"
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                            {selectedWorkingHour && (
                                                                                <div className="mt-5">
                                                                                    <TabellaTurnoGiornaliero
                                                                                        selectedWorkingHour={
                                                                                            selectedWorkingHour
                                                                                        }
                                                                                    />

                                                                                    <div className="mt-4 flex justify-center">
                                                                                        <button
                                                                                            type="button"
                                                                                            onClick={
                                                                                                handleSaveWorkingHour
                                                                                            }
                                                                                            className="rounded-md bg-indigo-600 px-5 py-2 text-xs font-semibold uppercase text-white shadow-sm transition-colors hover:bg-indigo-500"
                                                                                        >
                                                                                            Salva
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                        <div className="rounded-lg border border-dashed border-gray-300 bg-white py-8 text-center">
                                                                            <p className="text-sm font-semibold text-gray-700">
                                                                                Nessun turno giornaliero presente
                                                                            </p>

                                                                            <p className="mt-2 text-xs text-gray-500">
                                                                                Vai alla pagina di{" "}
                                                                                <Link to="/shift_management/create?type=daily&mode=scratch">
                                                                                    <span className="font-semibold uppercase text-indigo-600 underline">
                                                                                        creazione turno
                                                                                    </span>
                                                                                </Link>
                                                                            </p>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}

                                                            {selectedDay && selectedOption === "ASSEGNA TURNO SETTIMANALE" && (
                                                                <div className='bg-white p-3 rounded-xl border border-gray-200 shadow-md mb-3'>
                                                                    <div className="mb-4">
                                                                        <h3 className="text-sm font-semibold uppercase text-indigo-800">
                                                                            Assegna turno settimanale
                                                                        </h3>

                                                                        <p className="mt-1 text-xs text-gray-500">
                                                                            Seleziona la configurazione settimanale da applicare
                                                                        </p>
                                                                    </div>

                                                                    {weeklyWorkingHours.length > 0 ? (
                                                                        <>
                                                                            <div className="grid grid-cols-1 gap-2 sm:grid-cols-[200px_minmax(0,1fr)] sm:items-center">
                                                                                <label className="text-xs font-semibold text-gray-600">
                                                                                    Seleziona turno settimanale
                                                                                </label>

                                                                                <div className="min-w-0 rounded-md border border-gray-200 bg-white">
                                                                                    <ComboboxAutocomplete
                                                                                        options={weeklyWorkingHours}
                                                                                        bgActiveColor="bg-indigo-100"
                                                                                        textActiveColor="text-gray-900"
                                                                                        placeholder="Seleziona turno settimanale..."
                                                                                        onChange={(value) => setSelectedWeeklyWorkingHourId(value?.id ?? null)}
                                                                                        value={weeklyWorkingHours.find((weeklyWorkingHour) => weeklyWorkingHour.id === selectedWeeklyWorkingHourId) || null}
                                                                                        positionOptions="relative"
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                            {wwhEmployeeDataDisplay && isWeekWorkingHours(wwhEmployeeDataDisplay) && wwhEmployeeDataDisplay.slots_by_weekday?.length > 0 && (
                                                                                    <div className="mt-5">

                                                                                        {/* DESKTOP / TABLET */}
                                                                                        <div className="hidden overflow-x-auto rounded-lg border border-gray-200 bg-white shadow-sm md:block">
                                                                                            <table className="w-max min-w-full border-collapse">
                                                                                                <thead>
                                                                                                    <tr>
                                                                                                        {daysOfWeek.map((day, index) => (
                                                                                                            <th key={index} className="min-w-[140px] border border-gray-200 bg-indigo-50 px-3 py-2 text-center text-xs font-semibold uppercase text-gray-600">
                                                                                                                {day}
                                                                                                            </th>
                                                                                                        ))}
                                                                                                    </tr>
                                                                                                </thead>

                                                                                                <tbody>
                                                                                                    <tr>
                                                                                                        {daysOfWeek.map((day, columnIndex) => {
                                                                                                            const daySlots = (wwhEmployeeDataDisplay.slots_by_weekday || [])
                                                                                                                .flatMap((weekDay) => {
                                                                                                                    if (weekDay.week_day - 1 !== columnIndex) {
                                                                                                                        return [];
                                                                                                                    }

                                                                                                                    const timeSlots = weekDay.working_hour?.time_slots || [];
                                                                                                                    const additionalTimeSlots = weekDay.time_slots || [];

                                                                                                                    return [...timeSlots, ...additionalTimeSlots];
                                                                                                                })
                                                                                                                .sort((a, b) => a.start_at.localeCompare(b.start_at));

                                                                                                            return (
                                                                                                                <td key={columnIndex} className="min-w-[140px] border border-gray-200 p-2 align-top text-center">
                                                                                                                    {daySlots.length > 0 ? (
                                                                                                                        daySlots.map(
                                                                                                                            (timeSlot, timeSlotIndex) => (
                                                                                                                                <div key={`${columnIndex}-${timeSlotIndex}`} className="mb-2 p-2 last:mb-0">
                                                                                                                                    <div className="flex items-center justify-center gap-1.5">
                                                                                                                                        <BriefcaseIcon className="h-4 w-4 shrink-0 text-indigo-600" />
                                                                                                                                        <span className="whitespace-nowrap text-xs font-semibold text-gray-700">
                                                                                                                                            {timeSlot.start_at}{" "} -{" "}{timeSlot.end_at}
                                                                                                                                        </span>
                                                                                                                                    </div>

                                                                                                                                    {timeSlot.breaks?.map(
                                                                                                                                        (breakItem, breakIndex) => {
                                                                                                                                            const isHidden = !(breakItem?.is_visible ?? true);

                                                                                                                                            return (
                                                                                                                                                <div key={breakIndex} className="mt-1 flex items-center justify-center gap-1 text-xs">
                                                                                                                                                    {isHidden ? (
                                                                                                                                                        <EyeSlashIcon className="h-4 w-4 shrink-0 text-red-500" />
                                                                                                                                                    ) : (
                                                                                                                                                        <span className="inline-flex h-4 w-4 shrink-0 items-center justify-center">
                                                                                                                                                            <LocalBarIcon sx={{ fontSize: 14, color: "#4f46e5" }}
                                                                                                                                                            />
                                                                                                                                                        </span>
                                                                                                                                                    )}

                                                                                                                                                    <span className={`whitespace-nowrap ${isHidden ? "text-gray-400" : "text-gray-600"}`}>
                                                                                                                                                        {breakItem.start_at}{" "}-{" "}{breakItem.end_at}
                                                                                                                                                    </span>
                                                                                                                                                </div>
                                                                                                                                            );
                                                                                                                                        }
                                                                                                                                    )}
                                                                                                                                </div>
                                                                                                                            )
                                                                                                                        )
                                                                                                                    ) : (
                                                                                                                        <div className="py-3 text-xs text-transparent">
                                                                                                                            -
                                                                                                                        </div>
                                                                                                                    )}
                                                                                                                </td>
                                                                                                            );
                                                                                                        })}
                                                                                                    </tr>
                                                                                                </tbody>
                                                                                            </table>
                                                                                        </div>

                                                                                        {/* MOBILE */}
                                                                                        <div className="space-y-3 md:hidden">
                                                                                            {daysOfWeek.map((day, columnIndex) => {
                                                                                                const daySlots = (wwhEmployeeDataDisplay.slots_by_weekday || [])
                                                                                                    .flatMap((weekDay) => {
                                                                                                        if (weekDay.week_day - 1 !== columnIndex) {
                                                                                                            return [];
                                                                                                        }

                                                                                                        const timeSlots = weekDay.working_hour?.time_slots || [];
                                                                                                        const additionalTimeSlots = weekDay.time_slots || [];

                                                                                                        return [...timeSlots, ...additionalTimeSlots];
                                                                                                    })
                                                                                                    .sort((a, b) => a.start_at.localeCompare(b.start_at));

                                                                                                return (
                                                                                                    <div key={columnIndex} className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
                                                                                                        <div className="border-b border-indigo-100 bg-indigo-50 px-3 py-2">
                                                                                                            <p className="text-xs font-semibold uppercase text-indigo-700">
                                                                                                                {day}
                                                                                                            </p>
                                                                                                        </div>

                                                                                                        <div className="p-3">
                                                                                                            {daySlots.length > 0 ? (
                                                                                                                <div className="space-y-2">
                                                                                                                    {daySlots.map(
                                                                                                                        (timeSlot, timeSlotIndex) => (
                                                                                                                            <div key={`${columnIndex}-${timeSlotIndex}`} className="rounded-md border border-gray-200 bg-gray-50 px-3 py-2">
                                                                                                                                <div className="flex items-center gap-2">
                                                                                                                                    <BriefcaseIcon className="h-4 w-4 shrink-0 text-indigo-600" />

                                                                                                                                    <span className="text-xs font-semibold text-gray-700">
                                                                                                                                        {timeSlot.start_at}{" "}-{" "}{timeSlot.end_at}
                                                                                                                                    </span>
                                                                                                                                </div>

                                                                                                                                {timeSlot.breaks?.length > 0 && (
                                                                                                                                    <div className="mt-2 space-y-1 border-t border-gray-200 pt-2">
                                                                                                                                        {timeSlot.breaks.map(
                                                                                                                                            (breakItem, breakIndex) => {
                                                                                                                                                const isHidden = !(breakItem?.is_visible ?? true);

                                                                                                                                                return (
                                                                                                                                                    <div key={breakIndex} className="flex items-center gap-2 text-xs">
                                                                                                                                                        {isHidden ? (
                                                                                                                                                            <EyeSlashIcon className="h-4 w-4 shrink-0 text-red-500" />
                                                                                                                                                        ) : (
                                                                                                                                                            <span className="inline-flex h-4 w-4 shrink-0 items-center justify-center">
                                                                                                                                                                <LocalBarIcon sx={{ fontSize: 14, color: "#4f46e5" }}/>
                                                                                                                                                            </span>
                                                                                                                                                        )}

                                                                                                                                                        <span className={isHidden ? "text-gray-400" : "text-gray-600"}>
                                                                                                                                                            {breakItem.start_at}{" "}-{" "}{breakItem.end_at}
                                                                                                                                                        </span>
                                                                                                                                                    </div>
                                                                                                                                                );
                                                                                                                                            }
                                                                                                                                        )}
                                                                                                                                    </div>
                                                                                                                                )}
                                                                                                                            </div>
                                                                                                                        )
                                                                                                                    )}
                                                                                                                </div>
                                                                                                            ) : (
                                                                                                                <p className="py-1 text-xs text-gray-400">
                                                                                                                    Nessun orario configurato
                                                                                                                </p>
                                                                                                            )}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                );
                                                                                            })}
                                                                                        </div>

                                                                                        <div className="mt-4 text-center text-sm font-semibold text-gray-700">
                                                                                            Totale ore settimanali:{" "}{formatHoursAndMinutes(wwhEmployeeDataDisplay.duration / 60)}
                                                                                        </div>

                                                                                        <div className="mt-4 flex justify-center">
                                                                                            <button type="button" onClick={handleSaveWeekWorkingHour} className="rounded-md bg-indigo-600 px-5 py-2 text-xs font-semibold uppercase text-white shadow-sm transition-colors hover:bg-indigo-500">
                                                                                                Salva
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                        </>
                                                                    ) : (
                                                                        <div className="rounded-lg border border-dashed border-gray-300 bg-white py-8 text-center">
                                                                            <p className="text-sm font-semibold text-gray-700">
                                                                                Nessun turno settimanale presente
                                                                            </p>

                                                                            <p className="mt-2 text-xs text-gray-500">
                                                                                Vai alla pagina di{" "}
                                                                                <Link to="/shift_management/create?type=weekly&mode=scratch">
                                                                                    <span className="font-semibold uppercase text-indigo-600 underline">
                                                                                        creazione turno
                                                                                    </span>
                                                                                </Link>
                                                                            </p>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </Dialog.Panel>
                                        </Transition.Child>
                                    </div>
                                </div>
                            </Dialog>
                        </Transition.Root>
                    )}

                    {isModalOuPairingOpen && (
                        <OuSelectionPairDWH 
                            dailyWh={selectedDWH} 
                            onClose={closeModalPairingOuDWH} 
                            onSelectOUtoPair={handleSelectOUtoPair}
                        />
                    )}

                    {showModalAddGiustificativo && (
                        <AddGiustificativoModalAssignWH
                            closeModalAddGiustificativi={() => setShowModalAddGiustificativo(false)}
                            dipendente={selectedEmployee}
                            formattedDay={selectedDay}
                            onAfterSave={async (formattedDay, hasJustifications) => {
                                const updatedDayDetails = await getCalendarWorkingHour(
                                    token,
                                    formattedDay,
                                    null,
                                    [selectedEmployee.id],
                                    1,
                                    1
                                );

                                const employeeData = updatedDayDetails?.results?.[0]?.days?.find(day => day.date === formattedDay);

                                const justificationMinutes = employeeData?.justification_requests?.reduce((total, jr) => {
                                    if (jr.strategy === 'increase' && jr.duration) {
                                        return total + jr.duration;
                                    }
                                    return total;
                                }, 0) || 0;

                                setEmployeeWorkingHours((prev) =>
                                    prev.map((wh) =>
                                        wh.employeeId === selectedEmployee.id && wh.date === formattedDay
                                            ? {
                                                ...wh,
                                                has_justifications: hasJustifications,
                                                justification_duration_total: justificationMinutes,
                                                justification_requests: employeeData?.justification_requests || [], 
                                            }
                                            : wh
                                    )
                                );
                            }}
                            onSwitchToWorkingArea={handleSwitchJustificationToWorkingArea}
                            canManageJustifications={canManageJustifications}
                            canManageWorkingAreas={canManageWorkingAreas}
                            canViewWorkingAreas={canViewWorkingAreas}
                        />
                    )}

                    {/* {modalEditDailyWhOpen && (
                        <Transition.Root show={modalEditDailyWhOpen} as={Fragment}>
                        <Dialog className="relative z-10" onClose={handleEditDailyWhCloseModal}>
                            <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                            >
                            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                            </Transition.Child>

                            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-gray-50 items-center flex justify-center mx-8 shadow-xl transition-all my-8 w-3/4 2xl:w-2/4 py-4">
                                    <div className='px-4 w-full'>
                                    {selectedDay && selectedDailyWh && (
                                        <EditDailyWorkingHour
                                        selectedDay={selectedDay}
                                        dailyWhId={selectedDailyWh}
                                        // shiftData={selectedDailyWh}
                                        employeeId={employeeEditDailyWh}
                                        onShiftUpdated={(shiftData, index) => {
                                            // update the shift data logic here
                                        }}
                                        
                                        />
                                    )}
                                    
                                    <div className="mt-2 pt-2 justify-center">
                                        <button
                                        type="button"   
                                        className="py-2 bg-gray-200 rounded-md mb-2 w-28 text-gray-700"
                                        onClick={handleEditDailyWhCloseModal}
                                        >
                                        Chiudi
                                        </button>
                                    </div>
                                    </div>
                                </Dialog.Panel>
                                </Transition.Child>
                            </div>
                            </div>
                        </Dialog>
                        </Transition.Root>
                    )} */}
            </main>
            {showInactiveEmployee && profile.customer_type !== 'employee' && (
                <InactiveEmployeesTable onClose={() => setShowInactiveEmployee(false)} />
            )}

            <Footer />
        </div>
    );
};
export default V2TableAssignWh;


function OperationHeader({ title, description }) {
    return (
        <div className="mb-5 border-b border-gray-100 pb-3">
            <h3 className="text-sm font-semibold uppercase text-indigo-800">
                {title}
            </h3>

            <p className="mt-1 text-xs text-gray-500">
                {description}
            </p>
        </div>
    );
}


function EmptyShiftState({ type, href }) {
    return (
        <div className="rounded-lg border border-dashed border-gray-200 bg-gray-50 py-8 text-center">
            <p className="text-sm font-semibold text-gray-700">
                Nessun turno {type} presente
            </p>

            <p className="mt-2 text-xs text-gray-500">
                Vai alla pagina di{" "}
                <Link to={href}>
                    <span className="font-semibold uppercase text-indigo-600 underline">
                        creazione turno
                    </span>
                </Link>
            </p>
        </div>
    );
}

const SvgBreak = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg" 
            version="1.1" 
            id="Layer_1" 
            x="0px"
            y="0px" 
            viewBox="0 0 117 122.88" 
            style={{ width: '14px', margin: '4px' }}
        >
        <g>
          <path d="M94.8,15.36c-1.18-0.34-1.86-1.56-1.53-2.74c0.34-1.18,1.56-1.86,2.74-1.53c3.15,0.9,5.79,2.39,7.82,4.59 c2.03,2.22,3.39,5.1,3.94,8.79c0.18,1.21-0.66,2.34-1.88,2.52c-1.21,0.18-2.34-0.66-2.52-1.88c-0.41-2.76-1.38-4.87-2.81-6.43 C99.13,17.12,97.17,16.04,94.8,15.36L94.8,15.36z M37.87,67.17L0.61,28.09c-0.84-0.89-0.81-2.29,0.08-3.13 c0.43-0.41,0.98-0.61,1.53-0.61v-0.01h14.53L2.27,9.86c-0.87-0.87-0.87-2.27,0-3.14c0.87-0.87,2.27-0.87,3.14,0l17.62,17.62h42.2 c0.46-6.48,3.24-12.31,7.52-16.64C77.44,2.94,83.92,0,91.08,0c7.16,0,13.64,2.94,18.34,7.7C114.1,12.45,117,19,117,26.23 c0,7.23-2.9,13.78-7.58,18.53c-4.7,4.76-11.18,7.7-18.34,7.7c-3.19,0-6.25-0.59-9.09-1.66c-2.33-0.88-4.51-2.1-6.48-3.6L56,67.18 v38.38l14.94,13.45c0.91,0.82,0.98,2.22,0.16,3.13c-0.44,0.49-1.04,0.73-1.65,0.73v0H24.77c-1.23,0-2.22-0.99-2.22-2.22 c0-0.7,0.32-1.32,0.82-1.73l14.5-13.36V67.17L37.87,67.17z M69.68,24.34h22.88c1.23,0,2.22,0.99,2.22,2.22 c0,0.66-0.29,1.26-0.75,1.67L78.64,44c1.5,1.08,3.15,1.98,4.92,2.65c2.33,0.88,4.87,1.37,7.52,1.37c5.93,0,11.3-2.43,15.18-6.36 c3.89-3.94,6.3-9.39,6.3-15.42c0-6.03-2.41-11.48-6.3-15.42c-3.88-3.93-9.25-6.36-15.18-6.36c-5.93,0-11.3,2.43-15.18,6.36 C72.42,14.33,70.13,19.06,69.68,24.34L69.68,24.34z M7.4,28.78l6.82,7.15c0.14-0.03,0.29-0.05,0.45-0.05h64.77 c0.28,0,0.54,0.05,0.79,0.14l7.08-7.25H7.4L7.4,28.78z M18.41,40.33l23.18,24.31c0.45,0.41,0.73,0.99,0.73,1.65v40.26h0 c0,0.6-0.24,1.2-0.72,1.63l-11.14,10.26h33.22l-11.29-10.16c-0.5-0.41-0.83-1.03-0.83-1.73V66.28h0.01c0-0.56,0.21-1.11,0.63-1.55 l23.83-24.41H18.41L18.41,40.33z"/>
        </g>
      </svg>
    );
};


const PatternInactiveEmployee = () => {
    return {
        backgroundColor: '#ffffff',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23c7d2fe' fill-opacity='1' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zM6 5v1H5z'/%3E%3C/g%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat',
    };
};


const SvgHoliday = () => {
    return {
        backgroundColor: '#ffffff',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='48' height='32' viewBox='0 0 48 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23fde68a' fill-opacity='0.4'%3E%3Cpath d='M27 32c0-3.314 2.686-6 6-6 5.523 0 10-4.477 10-10S38.523 6 33 6c-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 6.627 0 12 5.373 12 12s-5.373 12-12 12c-2.21 0-4 1.79-4 4h-2zm-6 0c0-3.314-2.686-6-6-6-5.523 0-10-4.477-10-10S9.477 6 15 6c3.314 0 6-2.686 6-6h-2c0 2.21-1.79 4-4 4C8.373 4 3 9.373 3 16s5.373 12 12 12c2.21 0 4 1.79 4 4h2z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat',
    };
};

const SvgPattern = () => {
    return {
        backgroundColor: '#ffffff',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='48' height='32' viewBox='0 0 48 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23e0e7ff' fill-opacity='0.4'%3E%3Cpath d='M27 32c0-3.314 2.686-6 6-6 5.523 0 10-4.477 10-10S38.523 6 33 6c-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 6.627 0 12 5.373 12 12s-5.373 12-12 12c-2.21 0-4 1.79-4 4h-2zm-6 0c0-3.314-2.686-6-6-6-5.523 0-10-4.477-10-10S9.477 6 15 6c3.314 0 6-2.686 6-6h-2c0 2.21-1.79 4-4 4C8.373 4 3 9.373 3 16s5.373 12 12 12c2.21 0 4 1.79 4 4h2z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat',
    };
};


const TogglePillButton = ({
    active,
    onClick,
    icon: Icon,
    label,
    iconType = "hero",
}) => {
    return (
        <button
            type="button"
            onClick={onClick}
            aria-pressed={active}
            className={`
                group inline-flex h-8 items-center gap-1.5 rounded-full border px-3
                text-[12px] font-semibold
                transition-all duration-150
                focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1
                ${
                    active
                        ? "border-indigo-300 bg-indigo-50 text-indigo-700 shadow-sm"
                        : "border-indigo-200 bg-white text-gray-600 hover:border-indigo-200 hover:bg-indigo-50/40 hover:text-gray-800"
                }
            `}
        >
            {Icon && (
                iconType === "mui" ? (
                    <Icon
                        style={{ fontSize: "15px" }}
                        className={active ? "shrink-0 text-indigo-600" : "shrink-0 text-gray-400"}
                    />
                ) : (
                    <Icon className={`h-4 w-4 shrink-0 ${active ? "text-indigo-600" : "text-gray-400"}`} />
                )
            )}

            <span className="whitespace-nowrap text-[11px] font-bold uppercase tracking-wide text-indigo-500">
                {label}
            </span>

            {active && (<CheckIcon className="ml-0.5 h-3.5 w-3.5 text-indigo-600" />)}
        </button>
    );
};